/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type AdditionalDataHolder, type ApiError, type Guid, type Parsable, type ParseNode, type SerializationWriter } from '@microsoft/kiota-abstractions';

export interface AbortUploadRequest extends AdditionalDataHolder, Parsable {
    /**
     * The uploadId property
     */
    uploadId?: string | null;
}
export interface AddonQuantityRequest extends AdditionalDataHolder, Parsable {
    /**
     * The productId property
     */
    productId?: Guid | null;
    /**
     * The quantity property
     */
    quantity?: number | null;
}
export interface ArchivedFileRevisionResponse extends AdditionalDataHolder, Parsable {
    /**
     * The contentType property
     */
    contentType?: string | null;
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The directoryId property
     */
    directoryId?: Guid | null;
    /**
     * The fileId property
     */
    fileId?: Guid | null;
    /**
     * The fileName property
     */
    fileName?: string | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The ownerId property
     */
    ownerId?: Guid | null;
    /**
     * The parentRevisionId property
     */
    parentRevisionId?: Guid | null;
    /**
     * The persistance property
     */
    persistance?: string | null;
    /**
     * The previewUrls property
     */
    previewUrls?: ArchivedFileRevisionResponse_previewUrls | null;
    /**
     * The revisionName property
     */
    revisionName?: string | null;
    /**
     * The size property
     */
    size?: number | null;
    /**
     * The status property
     */
    status?: string | null;
    /**
     * The ttlSeconds property
     */
    ttlSeconds?: number | null;
    /**
     * The type property
     */
    type?: string | null;
}
export interface ArchivedFileRevisionResponse_previewUrls extends AdditionalDataHolder, Parsable {
}
export interface AudioMuteRangeRequest extends AdditionalDataHolder, Parsable {
    /**
     * The endSeconds property
     */
    endSeconds?: number | null;
    /**
     * The startSeconds property
     */
    startSeconds?: number | null;
}
export interface BillingProductResponse extends AdditionalDataHolder, Parsable {
    /**
     * The billingInterval property
     */
    billingInterval?: string | null;
    /**
     * The currency property
     */
    currency?: string | null;
    /**
     * The description property
     */
    description?: string | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The isAddon property
     */
    isAddon?: boolean | null;
    /**
     * The jobRuntimeSeconds property
     */
    jobRuntimeSeconds?: number | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The priceAmount property
     */
    priceAmount?: number | null;
    /**
     * The storageBytes property
     */
    storageBytes?: number | null;
}
export interface CancelSubscriptionRequest extends AdditionalDataHolder, Parsable {
    /**
     * The immediately property
     */
    immediately?: boolean | null;
}
export interface ChangePlanRequest extends AdditionalDataHolder, Parsable {
    /**
     * The productId property
     */
    productId?: Guid | null;
}
export interface CompletedPartInfo extends AdditionalDataHolder, Parsable {
    /**
     * The eTag property
     */
    eTag?: string | null;
    /**
     * The partNumber property
     */
    partNumber?: number | null;
}
export interface CompleteUploadRequest extends AdditionalDataHolder, Parsable {
    /**
     * The parts property
     */
    parts?: CompletedPartInfo[] | null;
    /**
     * The uploadId property
     */
    uploadId?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AbortUploadRequest}
 */
// @ts-ignore
export function createAbortUploadRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAbortUploadRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AddonQuantityRequest}
 */
// @ts-ignore
export function createAddonQuantityRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAddonQuantityRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ArchivedFileRevisionResponse_previewUrls}
 */
// @ts-ignore
export function createArchivedFileRevisionResponse_previewUrlsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoArchivedFileRevisionResponse_previewUrls;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ArchivedFileRevisionResponse}
 */
// @ts-ignore
export function createArchivedFileRevisionResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoArchivedFileRevisionResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {AudioMuteRangeRequest}
 */
// @ts-ignore
export function createAudioMuteRangeRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoAudioMuteRangeRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {BillingProductResponse}
 */
// @ts-ignore
export function createBillingProductResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoBillingProductResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CancelSubscriptionRequest}
 */
// @ts-ignore
export function createCancelSubscriptionRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCancelSubscriptionRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ChangePlanRequest}
 */
// @ts-ignore
export function createChangePlanRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoChangePlanRequest;
}
export interface CreateCheckoutSessionRequest extends AdditionalDataHolder, Parsable {
    /**
     * The addons property
     */
    addons?: AddonQuantityRequest[] | null;
    /**
     * The productId property
     */
    productId?: Guid | null;
}
export interface CreateCheckoutSessionResponse extends AdditionalDataHolder, Parsable {
    /**
     * The clientSecret property
     */
    clientSecret?: string | null;
    /**
     * The sessionId property
     */
    sessionId?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CompletedPartInfo}
 */
// @ts-ignore
export function createCompletedPartInfoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCompletedPartInfo;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CompleteUploadRequest}
 */
// @ts-ignore
export function createCompleteUploadRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCompleteUploadRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateCheckoutSessionRequest}
 */
// @ts-ignore
export function createCreateCheckoutSessionRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateCheckoutSessionRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateCheckoutSessionResponse}
 */
// @ts-ignore
export function createCreateCheckoutSessionResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateCheckoutSessionResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateDynamicWatermarkJobRequest}
 */
// @ts-ignore
export function createCreateDynamicWatermarkJobRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateDynamicWatermarkJobRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateFaceBlurJobRequest}
 */
// @ts-ignore
export function createCreateFaceBlurJobRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateFaceBlurJobRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateFileFromRevisionRequest}
 */
// @ts-ignore
export function createCreateFileFromRevisionRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateFileFromRevisionRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateFilePreviewJobRequest}
 */
// @ts-ignore
export function createCreateFilePreviewJobRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateFilePreviewJobRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateImageCropJobRequest}
 */
// @ts-ignore
export function createCreateImageCropJobRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateImageCropJobRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateImageWatermarkPresetRequest}
 */
// @ts-ignore
export function createCreateImageWatermarkPresetRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateImageWatermarkPresetRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateNotificationRequest}
 */
// @ts-ignore
export function createCreateNotificationRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateNotificationRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateRemoveAudioJobRequest}
 */
// @ts-ignore
export function createCreateRemoveAudioJobRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateRemoveAudioJobRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateRotateJobRequest}
 */
// @ts-ignore
export function createCreateRotateJobRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateRotateJobRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateSetupIntentResponse}
 */
// @ts-ignore
export function createCreateSetupIntentResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateSetupIntentResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateStaticBlurJobRequest}
 */
// @ts-ignore
export function createCreateStaticBlurJobRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateStaticBlurJobRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateTranscodingJobRequest}
 */
// @ts-ignore
export function createCreateTranscodingJobRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateTranscodingJobRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateVideoAudioEditJobRequest}
 */
// @ts-ignore
export function createCreateVideoAudioEditJobRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateVideoAudioEditJobRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateVideoScreenshotJobRequest}
 */
// @ts-ignore
export function createCreateVideoScreenshotJobRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateVideoScreenshotJobRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateVideoTrimJobRequest}
 */
// @ts-ignore
export function createCreateVideoTrimJobRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateVideoTrimJobRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {CreateWatermarkJobRequest}
 */
// @ts-ignore
export function createCreateWatermarkJobRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoCreateWatermarkJobRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DirectoryCopyRequest}
 */
// @ts-ignore
export function createDirectoryCopyRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDirectoryCopyRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DirectoryCreateRequest}
 */
// @ts-ignore
export function createDirectoryCreateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDirectoryCreateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DirectoryMoveRequest}
 */
// @ts-ignore
export function createDirectoryMoveRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDirectoryMoveRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DirectoryResponse}
 */
// @ts-ignore
export function createDirectoryResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDirectoryResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DirectoryShareCreateResponse}
 */
// @ts-ignore
export function createDirectoryShareCreateResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDirectoryShareCreateResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DirectoryShareResponse}
 */
// @ts-ignore
export function createDirectoryShareResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDirectoryShareResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DirectoryUpdateRequest}
 */
// @ts-ignore
export function createDirectoryUpdateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDirectoryUpdateRequest;
}
export interface CreateDynamicWatermarkJobRequest extends AdditionalDataHolder, Parsable {
    /**
     * The count property
     */
    count?: number | null;
    /**
     * The fileId property
     */
    fileId?: Guid | null;
    /**
     * The filename property
     */
    filename?: string | null;
    /**
     * The fontSize property
     */
    fontSize?: number | null;
    /**
     * The identifiers property
     */
    identifiers?: string[] | null;
    /**
     * The opacity property
     */
    opacity?: number | null;
    /**
     * The position property
     */
    position?: string | null;
    /**
     * The revisionId property
     */
    revisionId?: Guid | null;
    /**
     * The watermarkText property
     */
    watermarkText?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {DynamicWatermarkMatchResponse}
 */
// @ts-ignore
export function createDynamicWatermarkMatchResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoDynamicWatermarkMatchResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {EmailSignInRequest}
 */
// @ts-ignore
export function createEmailSignInRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoEmailSignInRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {EmailSignUpRequest}
 */
// @ts-ignore
export function createEmailSignUpRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoEmailSignUpRequest;
}
export interface CreateFaceBlurJobRequest extends AdditionalDataHolder, Parsable {
    /**
     * The detectionFps property
     */
    detectionFps?: number | null;
    /**
     * The filename property
     */
    filename?: string | null;
    /**
     * The minConfidence property
     */
    minConfidence?: number | null;
    /**
     * The mode property
     */
    mode?: string | null;
    /**
     * The padding property
     */
    padding?: number | null;
    /**
     * The shape property
     */
    shape?: string | null;
    /**
     * The strength property
     */
    strength?: number | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FileCopyRequest}
 */
// @ts-ignore
export function createFileCopyRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFileCopyRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FileDownloadResponse}
 */
// @ts-ignore
export function createFileDownloadResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFileDownloadResponse;
}
export interface CreateFileFromRevisionRequest extends AdditionalDataHolder, Parsable {
    /**
     * The destinationDirectoryId property
     */
    destinationDirectoryId?: Guid | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The revisionName property
     */
    revisionName?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FileMonthResponse}
 */
// @ts-ignore
export function createFileMonthResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFileMonthResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FileMoveRequest}
 */
// @ts-ignore
export function createFileMoveRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFileMoveRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FilePreviewGroupedResponse_urls}
 */
// @ts-ignore
export function createFilePreviewGroupedResponse_urlsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFilePreviewGroupedResponse_urls;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FilePreviewGroupedResponse}
 */
// @ts-ignore
export function createFilePreviewGroupedResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFilePreviewGroupedResponse;
}
export interface CreateFilePreviewJobRequest extends AdditionalDataHolder, Parsable {
    /**
     * The fileId property
     */
    fileId?: Guid | null;
    /**
     * The revisionId property
     */
    revisionId?: Guid | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FileResponse}
 */
// @ts-ignore
export function createFileResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFileResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FileRevisionResponse_previewUrls}
 */
// @ts-ignore
export function createFileRevisionResponse_previewUrlsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFileRevisionResponse_previewUrls;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FileRevisionResponse}
 */
// @ts-ignore
export function createFileRevisionResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFileRevisionResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FileShareCreateResponse}
 */
// @ts-ignore
export function createFileShareCreateResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFileShareCreateResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {FileShareResponse}
 */
// @ts-ignore
export function createFileShareResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoFileShareResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ForgotPasswordRequest}
 */
// @ts-ignore
export function createForgotPasswordRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoForgotPasswordRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {HttpValidationProblemDetails_errors}
 */
// @ts-ignore
export function createHttpValidationProblemDetails_errorsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoHttpValidationProblemDetails_errors;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {HttpValidationProblemDetails}
 */
// @ts-ignore
export function createHttpValidationProblemDetailsFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoHttpValidationProblemDetails;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {IdentifyDynamicWatermarkRequest}
 */
// @ts-ignore
export function createIdentifyDynamicWatermarkRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoIdentifyDynamicWatermarkRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {IdentifyDynamicWatermarkResponse}
 */
// @ts-ignore
export function createIdentifyDynamicWatermarkResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoIdentifyDynamicWatermarkResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {IError}
 */
// @ts-ignore
export function createIErrorFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoIError;
}
export interface CreateImageCropJobRequest extends AdditionalDataHolder, Parsable {
    /**
     * The filename property
     */
    filename?: string | null;
    /**
     * The height property
     */
    height?: number | null;
    /**
     * The width property
     */
    width?: number | null;
    /**
     * The x property
     */
    x?: number | null;
    /**
     * The y property
     */
    y?: number | null;
}
export interface CreateImageWatermarkPresetRequest extends AdditionalDataHolder, Parsable {
    /**
     * The count property
     */
    count?: number | null;
    /**
     * The imageWatermarkId property
     */
    imageWatermarkId?: Guid | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The opacity property
     */
    opacity?: number | null;
    /**
     * The placementMode property
     */
    placementMode?: string | null;
    /**
     * The position property
     */
    position?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ImageWatermarkPresetResponse}
 */
// @ts-ignore
export function createImageWatermarkPresetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoImageWatermarkPresetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ImageWatermarkResponse}
 */
// @ts-ignore
export function createImageWatermarkResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoImageWatermarkResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ImageWatermarkUploadResponse}
 */
// @ts-ignore
export function createImageWatermarkUploadResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoImageWatermarkUploadResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InitiateFileUploadRequest}
 */
// @ts-ignore
export function createInitiateFileUploadRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInitiateFileUploadRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InitiateImageWatermarkUploadRequest}
 */
// @ts-ignore
export function createInitiateImageWatermarkUploadRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInitiateImageWatermarkUploadRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InitiateRevisionUploadRequest}
 */
// @ts-ignore
export function createInitiateRevisionUploadRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInitiateRevisionUploadRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {InitiateVideoAudioInputUploadRequest}
 */
// @ts-ignore
export function createInitiateVideoAudioInputUploadRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoInitiateVideoAudioInputUploadRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {JobListResponse}
 */
// @ts-ignore
export function createJobListResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoJobListResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {JobResponse}
 */
// @ts-ignore
export function createJobResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoJobResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {JobStatusResponse}
 */
// @ts-ignore
export function createJobStatusResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoJobStatusResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {MultipartUploadResponse}
 */
// @ts-ignore
export function createMultipartUploadResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoMultipartUploadResponse;
}
export interface CreateNotificationRequest extends AdditionalDataHolder, Parsable {
    /**
     * The message property
     */
    message?: string | null;
    /**
     * The path property
     */
    path?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {NotificationResponse}
 */
// @ts-ignore
export function createNotificationResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoNotificationResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedResultOfArchivedFileRevisionResponse}
 */
// @ts-ignore
export function createPaginatedResultOfArchivedFileRevisionResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedResultOfArchivedFileRevisionResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedResultOfDirectoryResponse}
 */
// @ts-ignore
export function createPaginatedResultOfDirectoryResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedResultOfDirectoryResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedResultOfDirectoryShareResponse}
 */
// @ts-ignore
export function createPaginatedResultOfDirectoryShareResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedResultOfDirectoryShareResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedResultOfFilePreviewGroupedResponse}
 */
// @ts-ignore
export function createPaginatedResultOfFilePreviewGroupedResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedResultOfFilePreviewGroupedResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedResultOfFileResponse}
 */
// @ts-ignore
export function createPaginatedResultOfFileResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedResultOfFileResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedResultOfFileRevisionResponse}
 */
// @ts-ignore
export function createPaginatedResultOfFileRevisionResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedResultOfFileRevisionResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedResultOfFileShareResponse}
 */
// @ts-ignore
export function createPaginatedResultOfFileShareResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedResultOfFileShareResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedResultOfImageWatermarkPresetResponse}
 */
// @ts-ignore
export function createPaginatedResultOfImageWatermarkPresetResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedResultOfImageWatermarkPresetResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedResultOfImageWatermarkResponse}
 */
// @ts-ignore
export function createPaginatedResultOfImageWatermarkResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedResultOfImageWatermarkResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedResultOfJobListResponse}
 */
// @ts-ignore
export function createPaginatedResultOfJobListResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedResultOfJobListResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedResultOfNotificationResponse}
 */
// @ts-ignore
export function createPaginatedResultOfNotificationResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedResultOfNotificationResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedResultOfPendingFileResponse}
 */
// @ts-ignore
export function createPaginatedResultOfPendingFileResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedResultOfPendingFileResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedResultOfPendingRevisionResponse}
 */
// @ts-ignore
export function createPaginatedResultOfPendingRevisionResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedResultOfPendingRevisionResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedResultOfRevisionCommentResponse}
 */
// @ts-ignore
export function createPaginatedResultOfRevisionCommentResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedResultOfRevisionCommentResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedResultOfRevisionShareResponse}
 */
// @ts-ignore
export function createPaginatedResultOfRevisionShareResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedResultOfRevisionShareResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedResultOfTagResponse}
 */
// @ts-ignore
export function createPaginatedResultOfTagResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedResultOfTagResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaginatedResultOfTrashItemResponse}
 */
// @ts-ignore
export function createPaginatedResultOfTrashItemResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaginatedResultOfTrashItemResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PaymentMethodResponse}
 */
// @ts-ignore
export function createPaymentMethodResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPaymentMethodResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PendingFileResponse}
 */
// @ts-ignore
export function createPendingFileResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPendingFileResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PendingRevisionResponse}
 */
// @ts-ignore
export function createPendingRevisionResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPendingRevisionResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {PresignedPartUrl}
 */
// @ts-ignore
export function createPresignedPartUrlFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoPresignedPartUrl;
}
export interface CreateRemoveAudioJobRequest extends AdditionalDataHolder, Parsable {
    /**
     * The filename property
     */
    filename?: string | null;
    /**
     * The ranges property
     */
    ranges?: AudioMuteRangeRequest[] | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ResetPasswordRequest}
 */
// @ts-ignore
export function createResetPasswordRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoResetPasswordRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ResumeUploadRequest}
 */
// @ts-ignore
export function createResumeUploadRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoResumeUploadRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RevisionCommentCreateRequest}
 */
// @ts-ignore
export function createRevisionCommentCreateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRevisionCommentCreateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RevisionCommentMentionDto}
 */
// @ts-ignore
export function createRevisionCommentMentionDtoFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRevisionCommentMentionDto;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RevisionCommentResponse}
 */
// @ts-ignore
export function createRevisionCommentResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRevisionCommentResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RevisionCommentUpdateRequest}
 */
// @ts-ignore
export function createRevisionCommentUpdateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRevisionCommentUpdateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RevisionNoteResponse}
 */
// @ts-ignore
export function createRevisionNoteResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRevisionNoteResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RevisionNoteUpsertRequest}
 */
// @ts-ignore
export function createRevisionNoteUpsertRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRevisionNoteUpsertRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RevisionShareCreateResponse}
 */
// @ts-ignore
export function createRevisionShareCreateResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRevisionShareCreateResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {RevisionShareResponse}
 */
// @ts-ignore
export function createRevisionShareResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoRevisionShareResponse;
}
export interface CreateRotateJobRequest extends AdditionalDataHolder, Parsable {
    /**
     * The degrees property
     */
    degrees?: number | null;
    /**
     * The filename property
     */
    filename?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SetDefaultPaymentMethodRequest}
 */
// @ts-ignore
export function createSetDefaultPaymentMethodRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSetDefaultPaymentMethodRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SettingsUsageResponse}
 */
// @ts-ignore
export function createSettingsUsageResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSettingsUsageResponse;
}
export interface CreateSetupIntentResponse extends AdditionalDataHolder, Parsable {
    /**
     * The clientSecret property
     */
    clientSecret?: string | null;
    /**
     * The setupIntentId property
     */
    setupIntentId?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ShareCreateRequest}
 */
// @ts-ignore
export function createShareCreateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoShareCreateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SharedDirectoryResponse}
 */
// @ts-ignore
export function createSharedDirectoryResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSharedDirectoryResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {ShareUpdateRequest}
 */
// @ts-ignore
export function createShareUpdateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoShareUpdateRequest;
}
export interface CreateStaticBlurJobRequest extends AdditionalDataHolder, Parsable {
    /**
     * The filename property
     */
    filename?: string | null;
    /**
     * The regions property
     */
    regions?: StaticBlurRegionRequest[] | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {StaticBlurRegionRequest}
 */
// @ts-ignore
export function createStaticBlurRegionRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoStaticBlurRegionRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SubscriptionAddonResponse}
 */
// @ts-ignore
export function createSubscriptionAddonResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSubscriptionAddonResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {SubscriptionResponse}
 */
// @ts-ignore
export function createSubscriptionResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoSubscriptionResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TagCreateRequest}
 */
// @ts-ignore
export function createTagCreateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTagCreateRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TagResponse}
 */
// @ts-ignore
export function createTagResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTagResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TagUpdateRequest}
 */
// @ts-ignore
export function createTagUpdateRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTagUpdateRequest;
}
export interface CreateTranscodingJobRequest extends AdditionalDataHolder, Parsable {
    /**
     * The bitrate property
     */
    bitrate?: number | null;
    /**
     * The fileId property
     */
    fileId?: Guid | null;
    /**
     * The filename property
     */
    filename?: string | null;
    /**
     * The resolution property
     */
    resolution?: string | null;
    /**
     * The revisionId property
     */
    revisionId?: Guid | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {TrashItemResponse}
 */
// @ts-ignore
export function createTrashItemResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoTrashItemResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateAddonQuantityRequest}
 */
// @ts-ignore
export function createUpdateAddonQuantityRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateAddonQuantityRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateImageWatermarkPresetRequest}
 */
// @ts-ignore
export function createUpdateImageWatermarkPresetRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateImageWatermarkPresetRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {UpdateImageWatermarkRequest}
 */
// @ts-ignore
export function createUpdateImageWatermarkRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoUpdateImageWatermarkRequest;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {VideoAudioClipRequest}
 */
// @ts-ignore
export function createVideoAudioClipRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoVideoAudioClipRequest;
}
export interface CreateVideoAudioEditJobRequest extends AdditionalDataHolder, Parsable {
    /**
     * The clips property
     */
    clips?: VideoAudioClipRequest[] | null;
    /**
     * The filename property
     */
    filename?: string | null;
    /**
     * The mode property
     */
    mode?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {VideoAudioInputResponse}
 */
// @ts-ignore
export function createVideoAudioInputResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoVideoAudioInputResponse;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {VideoAudioInputUploadResponse}
 */
// @ts-ignore
export function createVideoAudioInputUploadResponseFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoVideoAudioInputUploadResponse;
}
export interface CreateVideoScreenshotJobRequest extends AdditionalDataHolder, Parsable {
    /**
     * The filename property
     */
    filename?: string | null;
    /**
     * The mode property
     */
    mode?: string | null;
    /**
     * The timestampSeconds property
     */
    timestampSeconds?: number | null;
}
export interface CreateVideoTrimJobRequest extends AdditionalDataHolder, Parsable {
    /**
     * The endSeconds property
     */
    endSeconds?: number | null;
    /**
     * The filename property
     */
    filename?: string | null;
    /**
     * The sections property
     */
    sections?: VideoTrimSectionRequest[] | null;
    /**
     * The startSeconds property
     */
    startSeconds?: number | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {VideoTrimSectionRequest}
 */
// @ts-ignore
export function createVideoTrimSectionRequestFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoVideoTrimSectionRequest;
}
export interface CreateWatermarkJobRequest extends AdditionalDataHolder, Parsable {
    /**
     * The count property
     */
    count?: number | null;
    /**
     * The fileId property
     */
    fileId?: Guid | null;
    /**
     * The filename property
     */
    filename?: string | null;
    /**
     * The fontSize property
     */
    fontSize?: number | null;
    /**
     * The opacity property
     */
    opacity?: number | null;
    /**
     * The position property
     */
    position?: string | null;
    /**
     * The presetId property
     */
    presetId?: Guid | null;
    /**
     * The revisionId property
     */
    revisionId?: Guid | null;
    /**
     * The text property
     */
    text?: string | null;
}
/**
 * Creates a new instance of the appropriate class based on discriminator value
 * @param parseNode The parse node to use to read the discriminator value and create the object
 * @returns {WatermarkPoint}
 */
// @ts-ignore
export function createWatermarkPointFromDiscriminatorValue(parseNode: ParseNode | undefined) : ((instance?: Parsable) => Record<string, (node: ParseNode) => void>) {
    return deserializeIntoWatermarkPoint;
}
/**
 * The deserialization information for the current model
 * @param AbortUploadRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAbortUploadRequest(abortUploadRequest: Partial<AbortUploadRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "uploadId": n => { abortUploadRequest.uploadId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param AddonQuantityRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAddonQuantityRequest(addonQuantityRequest: Partial<AddonQuantityRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "productId": n => { addonQuantityRequest.productId = n.getGuidValue(); },
        "quantity": n => { addonQuantityRequest.quantity = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ArchivedFileRevisionResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoArchivedFileRevisionResponse(archivedFileRevisionResponse: Partial<ArchivedFileRevisionResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "contentType": n => { archivedFileRevisionResponse.contentType = n.getStringValue(); },
        "createdAt": n => { archivedFileRevisionResponse.createdAt = n.getDateValue(); },
        "directoryId": n => { archivedFileRevisionResponse.directoryId = n.getGuidValue(); },
        "fileId": n => { archivedFileRevisionResponse.fileId = n.getGuidValue(); },
        "fileName": n => { archivedFileRevisionResponse.fileName = n.getStringValue(); },
        "id": n => { archivedFileRevisionResponse.id = n.getGuidValue(); },
        "ownerId": n => { archivedFileRevisionResponse.ownerId = n.getGuidValue(); },
        "parentRevisionId": n => { archivedFileRevisionResponse.parentRevisionId = n.getGuidValue(); },
        "persistance": n => { archivedFileRevisionResponse.persistance = n.getStringValue(); },
        "previewUrls": n => { archivedFileRevisionResponse.previewUrls = n.getObjectValue<ArchivedFileRevisionResponse_previewUrls>(createArchivedFileRevisionResponse_previewUrlsFromDiscriminatorValue); },
        "revisionName": n => { archivedFileRevisionResponse.revisionName = n.getStringValue(); },
        "size": n => { archivedFileRevisionResponse.size = n.getNumberValue(); },
        "status": n => { archivedFileRevisionResponse.status = n.getStringValue(); },
        "ttlSeconds": n => { archivedFileRevisionResponse.ttlSeconds = n.getNumberValue(); },
        "type": n => { archivedFileRevisionResponse.type = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ArchivedFileRevisionResponse_previewUrls The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoArchivedFileRevisionResponse_previewUrls(archivedFileRevisionResponse_previewUrls: Partial<ArchivedFileRevisionResponse_previewUrls> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @param AudioMuteRangeRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoAudioMuteRangeRequest(audioMuteRangeRequest: Partial<AudioMuteRangeRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "endSeconds": n => { audioMuteRangeRequest.endSeconds = n.getNumberValue(); },
        "startSeconds": n => { audioMuteRangeRequest.startSeconds = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param BillingProductResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoBillingProductResponse(billingProductResponse: Partial<BillingProductResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "billingInterval": n => { billingProductResponse.billingInterval = n.getStringValue(); },
        "currency": n => { billingProductResponse.currency = n.getStringValue(); },
        "description": n => { billingProductResponse.description = n.getStringValue(); },
        "id": n => { billingProductResponse.id = n.getGuidValue(); },
        "isAddon": n => { billingProductResponse.isAddon = n.getBooleanValue(); },
        "jobRuntimeSeconds": n => { billingProductResponse.jobRuntimeSeconds = n.getNumberValue(); },
        "name": n => { billingProductResponse.name = n.getStringValue(); },
        "priceAmount": n => { billingProductResponse.priceAmount = n.getNumberValue(); },
        "storageBytes": n => { billingProductResponse.storageBytes = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CancelSubscriptionRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCancelSubscriptionRequest(cancelSubscriptionRequest: Partial<CancelSubscriptionRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "immediately": n => { cancelSubscriptionRequest.immediately = n.getBooleanValue() ?? false; },
    }
}
/**
 * The deserialization information for the current model
 * @param ChangePlanRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoChangePlanRequest(changePlanRequest: Partial<ChangePlanRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "productId": n => { changePlanRequest.productId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CompletedPartInfo The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCompletedPartInfo(completedPartInfo: Partial<CompletedPartInfo> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "eTag": n => { completedPartInfo.eTag = n.getStringValue(); },
        "partNumber": n => { completedPartInfo.partNumber = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CompleteUploadRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCompleteUploadRequest(completeUploadRequest: Partial<CompleteUploadRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "parts": n => { completeUploadRequest.parts = n.getCollectionOfObjectValues<CompletedPartInfo>(createCompletedPartInfoFromDiscriminatorValue); },
        "uploadId": n => { completeUploadRequest.uploadId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateCheckoutSessionRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateCheckoutSessionRequest(createCheckoutSessionRequest: Partial<CreateCheckoutSessionRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "addons": n => { createCheckoutSessionRequest.addons = n.getCollectionOfObjectValues<AddonQuantityRequest>(createAddonQuantityRequestFromDiscriminatorValue); },
        "productId": n => { createCheckoutSessionRequest.productId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateCheckoutSessionResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateCheckoutSessionResponse(createCheckoutSessionResponse: Partial<CreateCheckoutSessionResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "clientSecret": n => { createCheckoutSessionResponse.clientSecret = n.getStringValue(); },
        "sessionId": n => { createCheckoutSessionResponse.sessionId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateDynamicWatermarkJobRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateDynamicWatermarkJobRequest(createDynamicWatermarkJobRequest: Partial<CreateDynamicWatermarkJobRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "count": n => { createDynamicWatermarkJobRequest.count = n.getNumberValue(); },
        "fileId": n => { createDynamicWatermarkJobRequest.fileId = n.getGuidValue(); },
        "filename": n => { createDynamicWatermarkJobRequest.filename = n.getStringValue(); },
        "fontSize": n => { createDynamicWatermarkJobRequest.fontSize = n.getNumberValue(); },
        "identifiers": n => { createDynamicWatermarkJobRequest.identifiers = n.getCollectionOfPrimitiveValues<string>("string"); },
        "opacity": n => { createDynamicWatermarkJobRequest.opacity = n.getNumberValue(); },
        "position": n => { createDynamicWatermarkJobRequest.position = n.getStringValue(); },
        "revisionId": n => { createDynamicWatermarkJobRequest.revisionId = n.getGuidValue(); },
        "watermarkText": n => { createDynamicWatermarkJobRequest.watermarkText = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateFaceBlurJobRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateFaceBlurJobRequest(createFaceBlurJobRequest: Partial<CreateFaceBlurJobRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "detectionFps": n => { createFaceBlurJobRequest.detectionFps = n.getNumberValue(); },
        "filename": n => { createFaceBlurJobRequest.filename = n.getStringValue(); },
        "minConfidence": n => { createFaceBlurJobRequest.minConfidence = n.getNumberValue(); },
        "mode": n => { createFaceBlurJobRequest.mode = n.getStringValue(); },
        "padding": n => { createFaceBlurJobRequest.padding = n.getNumberValue(); },
        "shape": n => { createFaceBlurJobRequest.shape = n.getStringValue(); },
        "strength": n => { createFaceBlurJobRequest.strength = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateFileFromRevisionRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateFileFromRevisionRequest(createFileFromRevisionRequest: Partial<CreateFileFromRevisionRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "destinationDirectoryId": n => { createFileFromRevisionRequest.destinationDirectoryId = n.getGuidValue(); },
        "name": n => { createFileFromRevisionRequest.name = n.getStringValue(); },
        "revisionName": n => { createFileFromRevisionRequest.revisionName = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateFilePreviewJobRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateFilePreviewJobRequest(createFilePreviewJobRequest: Partial<CreateFilePreviewJobRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "fileId": n => { createFilePreviewJobRequest.fileId = n.getGuidValue(); },
        "revisionId": n => { createFilePreviewJobRequest.revisionId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateImageCropJobRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateImageCropJobRequest(createImageCropJobRequest: Partial<CreateImageCropJobRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "filename": n => { createImageCropJobRequest.filename = n.getStringValue(); },
        "height": n => { createImageCropJobRequest.height = n.getNumberValue(); },
        "width": n => { createImageCropJobRequest.width = n.getNumberValue(); },
        "x": n => { createImageCropJobRequest.x = n.getNumberValue(); },
        "y": n => { createImageCropJobRequest.y = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateImageWatermarkPresetRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateImageWatermarkPresetRequest(createImageWatermarkPresetRequest: Partial<CreateImageWatermarkPresetRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "count": n => { createImageWatermarkPresetRequest.count = n.getNumberValue(); },
        "imageWatermarkId": n => { createImageWatermarkPresetRequest.imageWatermarkId = n.getGuidValue(); },
        "name": n => { createImageWatermarkPresetRequest.name = n.getStringValue(); },
        "opacity": n => { createImageWatermarkPresetRequest.opacity = n.getNumberValue(); },
        "placementMode": n => { createImageWatermarkPresetRequest.placementMode = n.getStringValue(); },
        "position": n => { createImageWatermarkPresetRequest.position = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateNotificationRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateNotificationRequest(createNotificationRequest: Partial<CreateNotificationRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "message": n => { createNotificationRequest.message = n.getStringValue(); },
        "path": n => { createNotificationRequest.path = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateRemoveAudioJobRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateRemoveAudioJobRequest(createRemoveAudioJobRequest: Partial<CreateRemoveAudioJobRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "filename": n => { createRemoveAudioJobRequest.filename = n.getStringValue(); },
        "ranges": n => { createRemoveAudioJobRequest.ranges = n.getCollectionOfObjectValues<AudioMuteRangeRequest>(createAudioMuteRangeRequestFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateRotateJobRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateRotateJobRequest(createRotateJobRequest: Partial<CreateRotateJobRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "degrees": n => { createRotateJobRequest.degrees = n.getNumberValue(); },
        "filename": n => { createRotateJobRequest.filename = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateSetupIntentResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateSetupIntentResponse(createSetupIntentResponse: Partial<CreateSetupIntentResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "clientSecret": n => { createSetupIntentResponse.clientSecret = n.getStringValue(); },
        "setupIntentId": n => { createSetupIntentResponse.setupIntentId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateStaticBlurJobRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateStaticBlurJobRequest(createStaticBlurJobRequest: Partial<CreateStaticBlurJobRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "filename": n => { createStaticBlurJobRequest.filename = n.getStringValue(); },
        "regions": n => { createStaticBlurJobRequest.regions = n.getCollectionOfObjectValues<StaticBlurRegionRequest>(createStaticBlurRegionRequestFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateTranscodingJobRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateTranscodingJobRequest(createTranscodingJobRequest: Partial<CreateTranscodingJobRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "bitrate": n => { createTranscodingJobRequest.bitrate = n.getNumberValue(); },
        "fileId": n => { createTranscodingJobRequest.fileId = n.getGuidValue(); },
        "filename": n => { createTranscodingJobRequest.filename = n.getStringValue(); },
        "resolution": n => { createTranscodingJobRequest.resolution = n.getStringValue(); },
        "revisionId": n => { createTranscodingJobRequest.revisionId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateVideoAudioEditJobRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateVideoAudioEditJobRequest(createVideoAudioEditJobRequest: Partial<CreateVideoAudioEditJobRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "clips": n => { createVideoAudioEditJobRequest.clips = n.getCollectionOfObjectValues<VideoAudioClipRequest>(createVideoAudioClipRequestFromDiscriminatorValue); },
        "filename": n => { createVideoAudioEditJobRequest.filename = n.getStringValue(); },
        "mode": n => { createVideoAudioEditJobRequest.mode = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateVideoScreenshotJobRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateVideoScreenshotJobRequest(createVideoScreenshotJobRequest: Partial<CreateVideoScreenshotJobRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "filename": n => { createVideoScreenshotJobRequest.filename = n.getStringValue(); },
        "mode": n => { createVideoScreenshotJobRequest.mode = n.getStringValue(); },
        "timestampSeconds": n => { createVideoScreenshotJobRequest.timestampSeconds = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateVideoTrimJobRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateVideoTrimJobRequest(createVideoTrimJobRequest: Partial<CreateVideoTrimJobRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "endSeconds": n => { createVideoTrimJobRequest.endSeconds = n.getNumberValue(); },
        "filename": n => { createVideoTrimJobRequest.filename = n.getStringValue(); },
        "sections": n => { createVideoTrimJobRequest.sections = n.getCollectionOfObjectValues<VideoTrimSectionRequest>(createVideoTrimSectionRequestFromDiscriminatorValue); },
        "startSeconds": n => { createVideoTrimJobRequest.startSeconds = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param CreateWatermarkJobRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoCreateWatermarkJobRequest(createWatermarkJobRequest: Partial<CreateWatermarkJobRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "count": n => { createWatermarkJobRequest.count = n.getNumberValue(); },
        "fileId": n => { createWatermarkJobRequest.fileId = n.getGuidValue(); },
        "filename": n => { createWatermarkJobRequest.filename = n.getStringValue(); },
        "fontSize": n => { createWatermarkJobRequest.fontSize = n.getNumberValue(); },
        "opacity": n => { createWatermarkJobRequest.opacity = n.getNumberValue(); },
        "position": n => { createWatermarkJobRequest.position = n.getStringValue(); },
        "presetId": n => { createWatermarkJobRequest.presetId = n.getGuidValue(); },
        "revisionId": n => { createWatermarkJobRequest.revisionId = n.getGuidValue(); },
        "text": n => { createWatermarkJobRequest.text = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param DirectoryCopyRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDirectoryCopyRequest(directoryCopyRequest: Partial<DirectoryCopyRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "destinationParentDirectoryId": n => { directoryCopyRequest.destinationParentDirectoryId = n.getGuidValue(); },
        "name": n => { directoryCopyRequest.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param DirectoryCreateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDirectoryCreateRequest(directoryCreateRequest: Partial<DirectoryCreateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "isPinned": n => { directoryCreateRequest.isPinned = n.getBooleanValue(); },
        "name": n => { directoryCreateRequest.name = n.getStringValue(); },
        "parentDirectoryId": n => { directoryCreateRequest.parentDirectoryId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param DirectoryMoveRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDirectoryMoveRequest(directoryMoveRequest: Partial<DirectoryMoveRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "destinationParentDirectoryId": n => { directoryMoveRequest.destinationParentDirectoryId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param DirectoryResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDirectoryResponse(directoryResponse: Partial<DirectoryResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "createdAt": n => { directoryResponse.createdAt = n.getDateValue(); },
        "id": n => { directoryResponse.id = n.getGuidValue(); },
        "isPinned": n => { directoryResponse.isPinned = n.getBooleanValue(); },
        "name": n => { directoryResponse.name = n.getStringValue(); },
        "parentDirectoryId": n => { directoryResponse.parentDirectoryId = n.getGuidValue(); },
        "status": n => { directoryResponse.status = n.getStringValue(); },
        "updatedAt": n => { directoryResponse.updatedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param DirectoryShareCreateResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDirectoryShareCreateResponse(directoryShareCreateResponse: Partial<DirectoryShareCreateResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "access": n => { directoryShareCreateResponse.access = n.getStringValue(); },
        "createdAt": n => { directoryShareCreateResponse.createdAt = n.getDateValue(); },
        "directoryId": n => { directoryShareCreateResponse.directoryId = n.getGuidValue(); },
        "expiresAt": n => { directoryShareCreateResponse.expiresAt = n.getDateValue(); },
        "id": n => { directoryShareCreateResponse.id = n.getGuidValue(); },
        "ownerId": n => { directoryShareCreateResponse.ownerId = n.getGuidValue(); },
        "status": n => { directoryShareCreateResponse.status = n.getStringValue(); },
        "token": n => { directoryShareCreateResponse.token = n.getStringValue(); },
        "updatedAt": n => { directoryShareCreateResponse.updatedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param DirectoryShareResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDirectoryShareResponse(directoryShareResponse: Partial<DirectoryShareResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "access": n => { directoryShareResponse.access = n.getStringValue(); },
        "createdAt": n => { directoryShareResponse.createdAt = n.getDateValue(); },
        "directoryId": n => { directoryShareResponse.directoryId = n.getGuidValue(); },
        "expiresAt": n => { directoryShareResponse.expiresAt = n.getDateValue(); },
        "id": n => { directoryShareResponse.id = n.getGuidValue(); },
        "ownerId": n => { directoryShareResponse.ownerId = n.getGuidValue(); },
        "status": n => { directoryShareResponse.status = n.getStringValue(); },
        "updatedAt": n => { directoryShareResponse.updatedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param DirectoryUpdateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDirectoryUpdateRequest(directoryUpdateRequest: Partial<DirectoryUpdateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "isPinned": n => { directoryUpdateRequest.isPinned = n.getBooleanValue(); },
        "name": n => { directoryUpdateRequest.name = n.getStringValue(); },
        "parentDirectoryId": n => { directoryUpdateRequest.parentDirectoryId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param DynamicWatermarkMatchResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoDynamicWatermarkMatchResponse(dynamicWatermarkMatchResponse: Partial<DynamicWatermarkMatchResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "algorithmVersion": n => { dynamicWatermarkMatchResponse.algorithmVersion = n.getNumberValue(); },
        "anchorMarked": n => { dynamicWatermarkMatchResponse.anchorMarked = n.getBooleanValue(); },
        "confidence": n => { dynamicWatermarkMatchResponse.confidence = n.getStringValue(); },
        "coverage": n => { dynamicWatermarkMatchResponse.coverage = n.getNumberValue(); },
        "expectedCollisions": n => { dynamicWatermarkMatchResponse.expectedCollisions = n.getNumberValue(); },
        "identifier": n => { dynamicWatermarkMatchResponse.identifier = n.getStringValue(); },
        "jobId": n => { dynamicWatermarkMatchResponse.jobId = n.getGuidValue(); },
        "matchedCount": n => { dynamicWatermarkMatchResponse.matchedCount = n.getNumberValue(); },
        "maxDistance": n => { dynamicWatermarkMatchResponse.maxDistance = n.getNumberValue(); },
        "meanDistance": n => { dynamicWatermarkMatchResponse.meanDistance = n.getNumberValue(); },
        "occurrences": n => { dynamicWatermarkMatchResponse.occurrences = n.getNumberValue(); },
        "patternSpace": n => { dynamicWatermarkMatchResponse.patternSpace = n.getNumberValue(); },
        "positions": n => { dynamicWatermarkMatchResponse.positions = n.getCollectionOfObjectValues<WatermarkPoint>(createWatermarkPointFromDiscriminatorValue); },
        "revisionId": n => { dynamicWatermarkMatchResponse.revisionId = n.getGuidValue(); },
        "revisionName": n => { dynamicWatermarkMatchResponse.revisionName = n.getStringValue(); },
        "watermarkCount": n => { dynamicWatermarkMatchResponse.watermarkCount = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param EmailSignInRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoEmailSignInRequest(emailSignInRequest: Partial<EmailSignInRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "callbackUrl": n => { emailSignInRequest.callbackUrl = n.getStringValue(); },
        "email": n => { emailSignInRequest.email = n.getStringValue(); },
        "password": n => { emailSignInRequest.password = n.getStringValue(); },
        "rememberMe": n => { emailSignInRequest.rememberMe = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param EmailSignUpRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoEmailSignUpRequest(emailSignUpRequest: Partial<EmailSignUpRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "callbackUrl": n => { emailSignUpRequest.callbackUrl = n.getStringValue(); },
        "email": n => { emailSignUpRequest.email = n.getStringValue(); },
        "image": n => { emailSignUpRequest.image = n.getStringValue(); },
        "name": n => { emailSignUpRequest.name = n.getStringValue(); },
        "password": n => { emailSignUpRequest.password = n.getStringValue(); },
        "rememberMe": n => { emailSignUpRequest.rememberMe = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param FileCopyRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFileCopyRequest(fileCopyRequest: Partial<FileCopyRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "destinationDirectoryId": n => { fileCopyRequest.destinationDirectoryId = n.getGuidValue(); },
        "name": n => { fileCopyRequest.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param FileDownloadResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFileDownloadResponse(fileDownloadResponse: Partial<FileDownloadResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "url": n => { fileDownloadResponse.url = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param FileMonthResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFileMonthResponse(fileMonthResponse: Partial<FileMonthResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "count": n => { fileMonthResponse.count = n.getNumberValue(); },
        "month": n => { fileMonthResponse.month = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param FileMoveRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFileMoveRequest(fileMoveRequest: Partial<FileMoveRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "destinationDirectoryId": n => { fileMoveRequest.destinationDirectoryId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param FilePreviewGroupedResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFilePreviewGroupedResponse(filePreviewGroupedResponse: Partial<FilePreviewGroupedResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "createdAt": n => { filePreviewGroupedResponse.createdAt = n.getDateValue(); },
        "fileId": n => { filePreviewGroupedResponse.fileId = n.getGuidValue(); },
        "revisionId": n => { filePreviewGroupedResponse.revisionId = n.getGuidValue(); },
        "status": n => { filePreviewGroupedResponse.status = n.getStringValue(); },
        "updatedAt": n => { filePreviewGroupedResponse.updatedAt = n.getDateValue(); },
        "urls": n => { filePreviewGroupedResponse.urls = n.getObjectValue<FilePreviewGroupedResponse_urls>(createFilePreviewGroupedResponse_urlsFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param FilePreviewGroupedResponse_urls The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFilePreviewGroupedResponse_urls(filePreviewGroupedResponse_urls: Partial<FilePreviewGroupedResponse_urls> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @param FileResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFileResponse(fileResponse: Partial<FileResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "createdAt": n => { fileResponse.createdAt = n.getDateValue(); },
        "directoryId": n => { fileResponse.directoryId = n.getGuidValue(); },
        "id": n => { fileResponse.id = n.getGuidValue(); },
        "latestRevision": n => { fileResponse.latestRevision = n.getObjectValue<FileRevisionResponse>(createFileRevisionResponseFromDiscriminatorValue); },
        "name": n => { fileResponse.name = n.getStringValue(); },
        "ownerId": n => { fileResponse.ownerId = n.getGuidValue(); },
        "revisionCount": n => { fileResponse.revisionCount = n.getNumberValue(); },
        "status": n => { fileResponse.status = n.getStringValue(); },
        "tags": n => { fileResponse.tags = n.getCollectionOfObjectValues<TagResponse>(createTagResponseFromDiscriminatorValue); },
        "updatedAt": n => { fileResponse.updatedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param FileRevisionResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFileRevisionResponse(fileRevisionResponse: Partial<FileRevisionResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "contentType": n => { fileRevisionResponse.contentType = n.getStringValue(); },
        "createdAt": n => { fileRevisionResponse.createdAt = n.getDateValue(); },
        "fileId": n => { fileRevisionResponse.fileId = n.getGuidValue(); },
        "id": n => { fileRevisionResponse.id = n.getGuidValue(); },
        "ownerId": n => { fileRevisionResponse.ownerId = n.getGuidValue(); },
        "parentRevisionId": n => { fileRevisionResponse.parentRevisionId = n.getGuidValue(); },
        "persistance": n => { fileRevisionResponse.persistance = n.getStringValue(); },
        "previewUrls": n => { fileRevisionResponse.previewUrls = n.getObjectValue<FileRevisionResponse_previewUrls>(createFileRevisionResponse_previewUrlsFromDiscriminatorValue); },
        "revisionName": n => { fileRevisionResponse.revisionName = n.getStringValue(); },
        "size": n => { fileRevisionResponse.size = n.getNumberValue(); },
        "status": n => { fileRevisionResponse.status = n.getStringValue(); },
        "ttlSeconds": n => { fileRevisionResponse.ttlSeconds = n.getNumberValue(); },
        "type": n => { fileRevisionResponse.type = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param FileRevisionResponse_previewUrls The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFileRevisionResponse_previewUrls(fileRevisionResponse_previewUrls: Partial<FileRevisionResponse_previewUrls> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @param FileShareCreateResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFileShareCreateResponse(fileShareCreateResponse: Partial<FileShareCreateResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "access": n => { fileShareCreateResponse.access = n.getStringValue(); },
        "createdAt": n => { fileShareCreateResponse.createdAt = n.getDateValue(); },
        "expiresAt": n => { fileShareCreateResponse.expiresAt = n.getDateValue(); },
        "fileId": n => { fileShareCreateResponse.fileId = n.getGuidValue(); },
        "id": n => { fileShareCreateResponse.id = n.getGuidValue(); },
        "ownerId": n => { fileShareCreateResponse.ownerId = n.getGuidValue(); },
        "status": n => { fileShareCreateResponse.status = n.getStringValue(); },
        "token": n => { fileShareCreateResponse.token = n.getStringValue(); },
        "updatedAt": n => { fileShareCreateResponse.updatedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param FileShareResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoFileShareResponse(fileShareResponse: Partial<FileShareResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "access": n => { fileShareResponse.access = n.getStringValue(); },
        "createdAt": n => { fileShareResponse.createdAt = n.getDateValue(); },
        "expiresAt": n => { fileShareResponse.expiresAt = n.getDateValue(); },
        "fileId": n => { fileShareResponse.fileId = n.getGuidValue(); },
        "id": n => { fileShareResponse.id = n.getGuidValue(); },
        "ownerId": n => { fileShareResponse.ownerId = n.getGuidValue(); },
        "status": n => { fileShareResponse.status = n.getStringValue(); },
        "updatedAt": n => { fileShareResponse.updatedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ForgotPasswordRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoForgotPasswordRequest(forgotPasswordRequest: Partial<ForgotPasswordRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "email": n => { forgotPasswordRequest.email = n.getStringValue(); },
        "redirectTo": n => { forgotPasswordRequest.redirectTo = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param HttpValidationProblemDetails The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoHttpValidationProblemDetails(httpValidationProblemDetails: Partial<HttpValidationProblemDetails> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "detail": n => { httpValidationProblemDetails.detail = n.getStringValue(); },
        "errors": n => { httpValidationProblemDetails.errors = n.getObjectValue<HttpValidationProblemDetails_errors>(createHttpValidationProblemDetails_errorsFromDiscriminatorValue); },
        "instance": n => { httpValidationProblemDetails.instance = n.getStringValue(); },
        "status": n => { httpValidationProblemDetails.status = n.getNumberValue(); },
        "title": n => { httpValidationProblemDetails.title = n.getStringValue(); },
        "type": n => { httpValidationProblemDetails.type = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param HttpValidationProblemDetails_errors The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoHttpValidationProblemDetails_errors(httpValidationProblemDetails_errors: Partial<HttpValidationProblemDetails_errors> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
    }
}
/**
 * The deserialization information for the current model
 * @param IdentifyDynamicWatermarkRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoIdentifyDynamicWatermarkRequest(identifyDynamicWatermarkRequest: Partial<IdentifyDynamicWatermarkRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "fileId": n => { identifyDynamicWatermarkRequest.fileId = n.getGuidValue(); },
        "points": n => { identifyDynamicWatermarkRequest.points = n.getCollectionOfObjectValues<WatermarkPoint>(createWatermarkPointFromDiscriminatorValue); },
        "tolerance": n => { identifyDynamicWatermarkRequest.tolerance = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param IdentifyDynamicWatermarkResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoIdentifyDynamicWatermarkResponse(identifyDynamicWatermarkResponse: Partial<IdentifyDynamicWatermarkResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "ambiguous": n => { identifyDynamicWatermarkResponse.ambiguous = n.getBooleanValue(); },
        "candidatesEvaluated": n => { identifyDynamicWatermarkResponse.candidatesEvaluated = n.getNumberValue(); },
        "matches": n => { identifyDynamicWatermarkResponse.matches = n.getCollectionOfObjectValues<DynamicWatermarkMatchResponse>(createDynamicWatermarkMatchResponseFromDiscriminatorValue); },
        "pointsEvaluated": n => { identifyDynamicWatermarkResponse.pointsEvaluated = n.getNumberValue(); },
        "totalMatches": n => { identifyDynamicWatermarkResponse.totalMatches = n.getNumberValue(); },
        "weakPattern": n => { identifyDynamicWatermarkResponse.weakPattern = n.getBooleanValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param IError The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoIError(iError: Partial<IError> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "message": n => { iError.messageEscaped = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ImageWatermarkPresetResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoImageWatermarkPresetResponse(imageWatermarkPresetResponse: Partial<ImageWatermarkPresetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "count": n => { imageWatermarkPresetResponse.count = n.getNumberValue(); },
        "createdAt": n => { imageWatermarkPresetResponse.createdAt = n.getDateValue(); },
        "id": n => { imageWatermarkPresetResponse.id = n.getGuidValue(); },
        "imageWatermarkId": n => { imageWatermarkPresetResponse.imageWatermarkId = n.getGuidValue(); },
        "imageWatermarkName": n => { imageWatermarkPresetResponse.imageWatermarkName = n.getStringValue(); },
        "name": n => { imageWatermarkPresetResponse.name = n.getStringValue(); },
        "opacity": n => { imageWatermarkPresetResponse.opacity = n.getNumberValue(); },
        "placementMode": n => { imageWatermarkPresetResponse.placementMode = n.getStringValue(); },
        "position": n => { imageWatermarkPresetResponse.position = n.getStringValue(); },
        "status": n => { imageWatermarkPresetResponse.status = n.getStringValue(); },
        "updatedAt": n => { imageWatermarkPresetResponse.updatedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ImageWatermarkResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoImageWatermarkResponse(imageWatermarkResponse: Partial<ImageWatermarkResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "contentType": n => { imageWatermarkResponse.contentType = n.getStringValue(); },
        "createdAt": n => { imageWatermarkResponse.createdAt = n.getDateValue(); },
        "downloadUrl": n => { imageWatermarkResponse.downloadUrl = n.getStringValue(); },
        "id": n => { imageWatermarkResponse.id = n.getGuidValue(); },
        "name": n => { imageWatermarkResponse.name = n.getStringValue(); },
        "size": n => { imageWatermarkResponse.size = n.getNumberValue(); },
        "status": n => { imageWatermarkResponse.status = n.getStringValue(); },
        "updatedAt": n => { imageWatermarkResponse.updatedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ImageWatermarkUploadResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoImageWatermarkUploadResponse(imageWatermarkUploadResponse: Partial<ImageWatermarkUploadResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "expiresAt": n => { imageWatermarkUploadResponse.expiresAt = n.getDateValue(); },
        "imageWatermarkId": n => { imageWatermarkUploadResponse.imageWatermarkId = n.getGuidValue(); },
        "partUrls": n => { imageWatermarkUploadResponse.partUrls = n.getCollectionOfObjectValues<PresignedPartUrl>(createPresignedPartUrlFromDiscriminatorValue); },
        "uploadId": n => { imageWatermarkUploadResponse.uploadId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param InitiateFileUploadRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInitiateFileUploadRequest(initiateFileUploadRequest: Partial<InitiateFileUploadRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "contentType": n => { initiateFileUploadRequest.contentType = n.getStringValue(); },
        "directoryId": n => { initiateFileUploadRequest.directoryId = n.getGuidValue(); },
        "fileName": n => { initiateFileUploadRequest.fileName = n.getStringValue(); },
        "partCount": n => { initiateFileUploadRequest.partCount = n.getNumberValue(); },
        "partSize": n => { initiateFileUploadRequest.partSize = n.getNumberValue(); },
        "persistance": n => { initiateFileUploadRequest.persistance = n.getStringValue(); },
        "size": n => { initiateFileUploadRequest.size = n.getNumberValue(); },
        "ttlSeconds": n => { initiateFileUploadRequest.ttlSeconds = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param InitiateImageWatermarkUploadRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInitiateImageWatermarkUploadRequest(initiateImageWatermarkUploadRequest: Partial<InitiateImageWatermarkUploadRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "contentType": n => { initiateImageWatermarkUploadRequest.contentType = n.getStringValue(); },
        "name": n => { initiateImageWatermarkUploadRequest.name = n.getStringValue(); },
        "partCount": n => { initiateImageWatermarkUploadRequest.partCount = n.getNumberValue(); },
        "size": n => { initiateImageWatermarkUploadRequest.size = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param InitiateRevisionUploadRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInitiateRevisionUploadRequest(initiateRevisionUploadRequest: Partial<InitiateRevisionUploadRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "contentType": n => { initiateRevisionUploadRequest.contentType = n.getStringValue(); },
        "parentRevisionId": n => { initiateRevisionUploadRequest.parentRevisionId = n.getGuidValue(); },
        "partCount": n => { initiateRevisionUploadRequest.partCount = n.getNumberValue(); },
        "persistance": n => { initiateRevisionUploadRequest.persistance = n.getStringValue(); },
        "revisionName": n => { initiateRevisionUploadRequest.revisionName = n.getStringValue(); },
        "size": n => { initiateRevisionUploadRequest.size = n.getNumberValue(); },
        "ttlSeconds": n => { initiateRevisionUploadRequest.ttlSeconds = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param InitiateVideoAudioInputUploadRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoInitiateVideoAudioInputUploadRequest(initiateVideoAudioInputUploadRequest: Partial<InitiateVideoAudioInputUploadRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "contentType": n => { initiateVideoAudioInputUploadRequest.contentType = n.getStringValue(); },
        "fileName": n => { initiateVideoAudioInputUploadRequest.fileName = n.getStringValue(); },
        "partCount": n => { initiateVideoAudioInputUploadRequest.partCount = n.getNumberValue(); },
        "size": n => { initiateVideoAudioInputUploadRequest.size = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param JobListResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoJobListResponse(jobListResponse: Partial<JobListResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "createdAt": n => { jobListResponse.createdAt = n.getDateValue(); },
        "fileId": n => { jobListResponse.fileId = n.getGuidValue(); },
        "fileName": n => { jobListResponse.fileName = n.getStringValue(); },
        "id": n => { jobListResponse.id = n.getGuidValue(); },
        "ownerId": n => { jobListResponse.ownerId = n.getGuidValue(); },
        "revisionName": n => { jobListResponse.revisionName = n.getStringValue(); },
        "status": n => { jobListResponse.status = n.getStringValue(); },
        "statusMessage": n => { jobListResponse.statusMessage = n.getStringValue(); },
        "type": n => { jobListResponse.type = n.getStringValue(); },
        "updatedAt": n => { jobListResponse.updatedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param JobResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoJobResponse(jobResponse: Partial<JobResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "jobId": n => { jobResponse.jobId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param JobStatusResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoJobStatusResponse(jobStatusResponse: Partial<JobStatusResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "createdAt": n => { jobStatusResponse.createdAt = n.getDateValue(); },
        "id": n => { jobStatusResponse.id = n.getGuidValue(); },
        "status": n => { jobStatusResponse.status = n.getStringValue(); },
        "statusMessage": n => { jobStatusResponse.statusMessage = n.getStringValue(); },
        "type": n => { jobStatusResponse.type = n.getStringValue(); },
        "updatedAt": n => { jobStatusResponse.updatedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param MultipartUploadResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoMultipartUploadResponse(multipartUploadResponse: Partial<MultipartUploadResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "expiresAt": n => { multipartUploadResponse.expiresAt = n.getDateValue(); },
        "fileId": n => { multipartUploadResponse.fileId = n.getGuidValue(); },
        "partSize": n => { multipartUploadResponse.partSize = n.getNumberValue(); },
        "partUrls": n => { multipartUploadResponse.partUrls = n.getCollectionOfObjectValues<PresignedPartUrl>(createPresignedPartUrlFromDiscriminatorValue); },
        "revisionId": n => { multipartUploadResponse.revisionId = n.getGuidValue(); },
        "uploadId": n => { multipartUploadResponse.uploadId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param NotificationResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoNotificationResponse(notificationResponse: Partial<NotificationResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "createdAt": n => { notificationResponse.createdAt = n.getDateValue(); },
        "id": n => { notificationResponse.id = n.getGuidValue(); },
        "isRead": n => { notificationResponse.isRead = n.getBooleanValue(); },
        "message": n => { notificationResponse.message = n.getStringValue(); },
        "path": n => { notificationResponse.path = n.getStringValue(); },
        "userId": n => { notificationResponse.userId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedResultOfArchivedFileRevisionResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedResultOfArchivedFileRevisionResponse(paginatedResultOfArchivedFileRevisionResponse: Partial<PaginatedResultOfArchivedFileRevisionResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedResultOfArchivedFileRevisionResponse.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedResultOfArchivedFileRevisionResponse.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedResultOfArchivedFileRevisionResponse.items = n.getCollectionOfObjectValues<ArchivedFileRevisionResponse>(createArchivedFileRevisionResponseFromDiscriminatorValue); },
        "page": n => { paginatedResultOfArchivedFileRevisionResponse.page = n.getNumberValue(); },
        "pageSize": n => { paginatedResultOfArchivedFileRevisionResponse.pageSize = n.getNumberValue(); },
        "totalCount": n => { paginatedResultOfArchivedFileRevisionResponse.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedResultOfArchivedFileRevisionResponse.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedResultOfDirectoryResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedResultOfDirectoryResponse(paginatedResultOfDirectoryResponse: Partial<PaginatedResultOfDirectoryResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedResultOfDirectoryResponse.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedResultOfDirectoryResponse.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedResultOfDirectoryResponse.items = n.getCollectionOfObjectValues<DirectoryResponse>(createDirectoryResponseFromDiscriminatorValue); },
        "page": n => { paginatedResultOfDirectoryResponse.page = n.getNumberValue(); },
        "pageSize": n => { paginatedResultOfDirectoryResponse.pageSize = n.getNumberValue(); },
        "totalCount": n => { paginatedResultOfDirectoryResponse.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedResultOfDirectoryResponse.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedResultOfDirectoryShareResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedResultOfDirectoryShareResponse(paginatedResultOfDirectoryShareResponse: Partial<PaginatedResultOfDirectoryShareResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedResultOfDirectoryShareResponse.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedResultOfDirectoryShareResponse.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedResultOfDirectoryShareResponse.items = n.getCollectionOfObjectValues<DirectoryShareResponse>(createDirectoryShareResponseFromDiscriminatorValue); },
        "page": n => { paginatedResultOfDirectoryShareResponse.page = n.getNumberValue(); },
        "pageSize": n => { paginatedResultOfDirectoryShareResponse.pageSize = n.getNumberValue(); },
        "totalCount": n => { paginatedResultOfDirectoryShareResponse.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedResultOfDirectoryShareResponse.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedResultOfFilePreviewGroupedResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedResultOfFilePreviewGroupedResponse(paginatedResultOfFilePreviewGroupedResponse: Partial<PaginatedResultOfFilePreviewGroupedResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedResultOfFilePreviewGroupedResponse.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedResultOfFilePreviewGroupedResponse.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedResultOfFilePreviewGroupedResponse.items = n.getCollectionOfObjectValues<FilePreviewGroupedResponse>(createFilePreviewGroupedResponseFromDiscriminatorValue); },
        "page": n => { paginatedResultOfFilePreviewGroupedResponse.page = n.getNumberValue(); },
        "pageSize": n => { paginatedResultOfFilePreviewGroupedResponse.pageSize = n.getNumberValue(); },
        "totalCount": n => { paginatedResultOfFilePreviewGroupedResponse.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedResultOfFilePreviewGroupedResponse.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedResultOfFileResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedResultOfFileResponse(paginatedResultOfFileResponse: Partial<PaginatedResultOfFileResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedResultOfFileResponse.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedResultOfFileResponse.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedResultOfFileResponse.items = n.getCollectionOfObjectValues<FileResponse>(createFileResponseFromDiscriminatorValue); },
        "page": n => { paginatedResultOfFileResponse.page = n.getNumberValue(); },
        "pageSize": n => { paginatedResultOfFileResponse.pageSize = n.getNumberValue(); },
        "totalCount": n => { paginatedResultOfFileResponse.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedResultOfFileResponse.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedResultOfFileRevisionResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedResultOfFileRevisionResponse(paginatedResultOfFileRevisionResponse: Partial<PaginatedResultOfFileRevisionResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedResultOfFileRevisionResponse.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedResultOfFileRevisionResponse.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedResultOfFileRevisionResponse.items = n.getCollectionOfObjectValues<FileRevisionResponse>(createFileRevisionResponseFromDiscriminatorValue); },
        "page": n => { paginatedResultOfFileRevisionResponse.page = n.getNumberValue(); },
        "pageSize": n => { paginatedResultOfFileRevisionResponse.pageSize = n.getNumberValue(); },
        "totalCount": n => { paginatedResultOfFileRevisionResponse.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedResultOfFileRevisionResponse.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedResultOfFileShareResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedResultOfFileShareResponse(paginatedResultOfFileShareResponse: Partial<PaginatedResultOfFileShareResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedResultOfFileShareResponse.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedResultOfFileShareResponse.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedResultOfFileShareResponse.items = n.getCollectionOfObjectValues<FileShareResponse>(createFileShareResponseFromDiscriminatorValue); },
        "page": n => { paginatedResultOfFileShareResponse.page = n.getNumberValue(); },
        "pageSize": n => { paginatedResultOfFileShareResponse.pageSize = n.getNumberValue(); },
        "totalCount": n => { paginatedResultOfFileShareResponse.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedResultOfFileShareResponse.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedResultOfImageWatermarkPresetResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedResultOfImageWatermarkPresetResponse(paginatedResultOfImageWatermarkPresetResponse: Partial<PaginatedResultOfImageWatermarkPresetResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedResultOfImageWatermarkPresetResponse.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedResultOfImageWatermarkPresetResponse.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedResultOfImageWatermarkPresetResponse.items = n.getCollectionOfObjectValues<ImageWatermarkPresetResponse>(createImageWatermarkPresetResponseFromDiscriminatorValue); },
        "page": n => { paginatedResultOfImageWatermarkPresetResponse.page = n.getNumberValue(); },
        "pageSize": n => { paginatedResultOfImageWatermarkPresetResponse.pageSize = n.getNumberValue(); },
        "totalCount": n => { paginatedResultOfImageWatermarkPresetResponse.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedResultOfImageWatermarkPresetResponse.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedResultOfImageWatermarkResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedResultOfImageWatermarkResponse(paginatedResultOfImageWatermarkResponse: Partial<PaginatedResultOfImageWatermarkResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedResultOfImageWatermarkResponse.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedResultOfImageWatermarkResponse.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedResultOfImageWatermarkResponse.items = n.getCollectionOfObjectValues<ImageWatermarkResponse>(createImageWatermarkResponseFromDiscriminatorValue); },
        "page": n => { paginatedResultOfImageWatermarkResponse.page = n.getNumberValue(); },
        "pageSize": n => { paginatedResultOfImageWatermarkResponse.pageSize = n.getNumberValue(); },
        "totalCount": n => { paginatedResultOfImageWatermarkResponse.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedResultOfImageWatermarkResponse.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedResultOfJobListResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedResultOfJobListResponse(paginatedResultOfJobListResponse: Partial<PaginatedResultOfJobListResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedResultOfJobListResponse.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedResultOfJobListResponse.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedResultOfJobListResponse.items = n.getCollectionOfObjectValues<JobListResponse>(createJobListResponseFromDiscriminatorValue); },
        "page": n => { paginatedResultOfJobListResponse.page = n.getNumberValue(); },
        "pageSize": n => { paginatedResultOfJobListResponse.pageSize = n.getNumberValue(); },
        "totalCount": n => { paginatedResultOfJobListResponse.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedResultOfJobListResponse.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedResultOfNotificationResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedResultOfNotificationResponse(paginatedResultOfNotificationResponse: Partial<PaginatedResultOfNotificationResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedResultOfNotificationResponse.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedResultOfNotificationResponse.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedResultOfNotificationResponse.items = n.getCollectionOfObjectValues<NotificationResponse>(createNotificationResponseFromDiscriminatorValue); },
        "page": n => { paginatedResultOfNotificationResponse.page = n.getNumberValue(); },
        "pageSize": n => { paginatedResultOfNotificationResponse.pageSize = n.getNumberValue(); },
        "totalCount": n => { paginatedResultOfNotificationResponse.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedResultOfNotificationResponse.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedResultOfPendingFileResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedResultOfPendingFileResponse(paginatedResultOfPendingFileResponse: Partial<PaginatedResultOfPendingFileResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedResultOfPendingFileResponse.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedResultOfPendingFileResponse.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedResultOfPendingFileResponse.items = n.getCollectionOfObjectValues<PendingFileResponse>(createPendingFileResponseFromDiscriminatorValue); },
        "page": n => { paginatedResultOfPendingFileResponse.page = n.getNumberValue(); },
        "pageSize": n => { paginatedResultOfPendingFileResponse.pageSize = n.getNumberValue(); },
        "totalCount": n => { paginatedResultOfPendingFileResponse.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedResultOfPendingFileResponse.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedResultOfPendingRevisionResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedResultOfPendingRevisionResponse(paginatedResultOfPendingRevisionResponse: Partial<PaginatedResultOfPendingRevisionResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedResultOfPendingRevisionResponse.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedResultOfPendingRevisionResponse.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedResultOfPendingRevisionResponse.items = n.getCollectionOfObjectValues<PendingRevisionResponse>(createPendingRevisionResponseFromDiscriminatorValue); },
        "page": n => { paginatedResultOfPendingRevisionResponse.page = n.getNumberValue(); },
        "pageSize": n => { paginatedResultOfPendingRevisionResponse.pageSize = n.getNumberValue(); },
        "totalCount": n => { paginatedResultOfPendingRevisionResponse.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedResultOfPendingRevisionResponse.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedResultOfRevisionCommentResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedResultOfRevisionCommentResponse(paginatedResultOfRevisionCommentResponse: Partial<PaginatedResultOfRevisionCommentResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedResultOfRevisionCommentResponse.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedResultOfRevisionCommentResponse.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedResultOfRevisionCommentResponse.items = n.getCollectionOfObjectValues<RevisionCommentResponse>(createRevisionCommentResponseFromDiscriminatorValue); },
        "page": n => { paginatedResultOfRevisionCommentResponse.page = n.getNumberValue(); },
        "pageSize": n => { paginatedResultOfRevisionCommentResponse.pageSize = n.getNumberValue(); },
        "totalCount": n => { paginatedResultOfRevisionCommentResponse.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedResultOfRevisionCommentResponse.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedResultOfRevisionShareResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedResultOfRevisionShareResponse(paginatedResultOfRevisionShareResponse: Partial<PaginatedResultOfRevisionShareResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedResultOfRevisionShareResponse.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedResultOfRevisionShareResponse.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedResultOfRevisionShareResponse.items = n.getCollectionOfObjectValues<RevisionShareResponse>(createRevisionShareResponseFromDiscriminatorValue); },
        "page": n => { paginatedResultOfRevisionShareResponse.page = n.getNumberValue(); },
        "pageSize": n => { paginatedResultOfRevisionShareResponse.pageSize = n.getNumberValue(); },
        "totalCount": n => { paginatedResultOfRevisionShareResponse.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedResultOfRevisionShareResponse.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedResultOfTagResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedResultOfTagResponse(paginatedResultOfTagResponse: Partial<PaginatedResultOfTagResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedResultOfTagResponse.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedResultOfTagResponse.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedResultOfTagResponse.items = n.getCollectionOfObjectValues<TagResponse>(createTagResponseFromDiscriminatorValue); },
        "page": n => { paginatedResultOfTagResponse.page = n.getNumberValue(); },
        "pageSize": n => { paginatedResultOfTagResponse.pageSize = n.getNumberValue(); },
        "totalCount": n => { paginatedResultOfTagResponse.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedResultOfTagResponse.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaginatedResultOfTrashItemResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaginatedResultOfTrashItemResponse(paginatedResultOfTrashItemResponse: Partial<PaginatedResultOfTrashItemResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "hasNextPage": n => { paginatedResultOfTrashItemResponse.hasNextPage = n.getBooleanValue(); },
        "hasPreviousPage": n => { paginatedResultOfTrashItemResponse.hasPreviousPage = n.getBooleanValue(); },
        "items": n => { paginatedResultOfTrashItemResponse.items = n.getCollectionOfObjectValues<TrashItemResponse>(createTrashItemResponseFromDiscriminatorValue); },
        "page": n => { paginatedResultOfTrashItemResponse.page = n.getNumberValue(); },
        "pageSize": n => { paginatedResultOfTrashItemResponse.pageSize = n.getNumberValue(); },
        "totalCount": n => { paginatedResultOfTrashItemResponse.totalCount = n.getNumberValue(); },
        "totalPages": n => { paginatedResultOfTrashItemResponse.totalPages = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PaymentMethodResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPaymentMethodResponse(paymentMethodResponse: Partial<PaymentMethodResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "brand": n => { paymentMethodResponse.brand = n.getStringValue(); },
        "expMonth": n => { paymentMethodResponse.expMonth = n.getNumberValue(); },
        "expYear": n => { paymentMethodResponse.expYear = n.getNumberValue(); },
        "id": n => { paymentMethodResponse.id = n.getStringValue(); },
        "isDefault": n => { paymentMethodResponse.isDefault = n.getBooleanValue(); },
        "last4": n => { paymentMethodResponse.last4 = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PendingFileResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPendingFileResponse(pendingFileResponse: Partial<PendingFileResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "contentType": n => { pendingFileResponse.contentType = n.getStringValue(); },
        "createdAt": n => { pendingFileResponse.createdAt = n.getDateValue(); },
        "directoryId": n => { pendingFileResponse.directoryId = n.getGuidValue(); },
        "extUploadId": n => { pendingFileResponse.extUploadId = n.getStringValue(); },
        "fileId": n => { pendingFileResponse.fileId = n.getGuidValue(); },
        "fileName": n => { pendingFileResponse.fileName = n.getStringValue(); },
        "persistance": n => { pendingFileResponse.persistance = n.getStringValue(); },
        "revisionId": n => { pendingFileResponse.revisionId = n.getGuidValue(); },
        "size": n => { pendingFileResponse.size = n.getNumberValue(); },
        "ttlSeconds": n => { pendingFileResponse.ttlSeconds = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PendingRevisionResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPendingRevisionResponse(pendingRevisionResponse: Partial<PendingRevisionResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "contentType": n => { pendingRevisionResponse.contentType = n.getStringValue(); },
        "createdAt": n => { pendingRevisionResponse.createdAt = n.getDateValue(); },
        "extUploadId": n => { pendingRevisionResponse.extUploadId = n.getStringValue(); },
        "fileId": n => { pendingRevisionResponse.fileId = n.getGuidValue(); },
        "fileName": n => { pendingRevisionResponse.fileName = n.getStringValue(); },
        "persistance": n => { pendingRevisionResponse.persistance = n.getStringValue(); },
        "revisionId": n => { pendingRevisionResponse.revisionId = n.getGuidValue(); },
        "revisionName": n => { pendingRevisionResponse.revisionName = n.getStringValue(); },
        "size": n => { pendingRevisionResponse.size = n.getNumberValue(); },
        "ttlSeconds": n => { pendingRevisionResponse.ttlSeconds = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param PresignedPartUrl The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoPresignedPartUrl(presignedPartUrl: Partial<PresignedPartUrl> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "partNumber": n => { presignedPartUrl.partNumber = n.getNumberValue(); },
        "url": n => { presignedPartUrl.url = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ResetPasswordRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoResetPasswordRequest(resetPasswordRequest: Partial<ResetPasswordRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "newPassword": n => { resetPasswordRequest.newPassword = n.getStringValue(); },
        "token": n => { resetPasswordRequest.token = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ResumeUploadRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoResumeUploadRequest(resumeUploadRequest: Partial<ResumeUploadRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "partCount": n => { resumeUploadRequest.partCount = n.getNumberValue(); },
        "partSize": n => { resumeUploadRequest.partSize = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param RevisionCommentCreateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRevisionCommentCreateRequest(revisionCommentCreateRequest: Partial<RevisionCommentCreateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "content": n => { revisionCommentCreateRequest.content = n.getStringValue(); },
        "mentions": n => { revisionCommentCreateRequest.mentions = n.getCollectionOfObjectValues<RevisionCommentMentionDto>(createRevisionCommentMentionDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param RevisionCommentMentionDto The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRevisionCommentMentionDto(revisionCommentMentionDto: Partial<RevisionCommentMentionDto> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "length": n => { revisionCommentMentionDto.length = n.getNumberValue(); },
        "start": n => { revisionCommentMentionDto.start = n.getNumberValue(); },
        "userId": n => { revisionCommentMentionDto.userId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param RevisionCommentResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRevisionCommentResponse(revisionCommentResponse: Partial<RevisionCommentResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "authorId": n => { revisionCommentResponse.authorId = n.getGuidValue(); },
        "content": n => { revisionCommentResponse.content = n.getStringValue(); },
        "createdAt": n => { revisionCommentResponse.createdAt = n.getDateValue(); },
        "id": n => { revisionCommentResponse.id = n.getGuidValue(); },
        "mentions": n => { revisionCommentResponse.mentions = n.getCollectionOfObjectValues<RevisionCommentMentionDto>(createRevisionCommentMentionDtoFromDiscriminatorValue); },
        "revisionId": n => { revisionCommentResponse.revisionId = n.getGuidValue(); },
        "status": n => { revisionCommentResponse.status = n.getStringValue(); },
        "updatedAt": n => { revisionCommentResponse.updatedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param RevisionCommentUpdateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRevisionCommentUpdateRequest(revisionCommentUpdateRequest: Partial<RevisionCommentUpdateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "content": n => { revisionCommentUpdateRequest.content = n.getStringValue(); },
        "mentions": n => { revisionCommentUpdateRequest.mentions = n.getCollectionOfObjectValues<RevisionCommentMentionDto>(createRevisionCommentMentionDtoFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param RevisionNoteResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRevisionNoteResponse(revisionNoteResponse: Partial<RevisionNoteResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "content": n => { revisionNoteResponse.content = n.getStringValue(); },
        "createdAt": n => { revisionNoteResponse.createdAt = n.getDateValue(); },
        "id": n => { revisionNoteResponse.id = n.getGuidValue(); },
        "revisionId": n => { revisionNoteResponse.revisionId = n.getGuidValue(); },
        "status": n => { revisionNoteResponse.status = n.getStringValue(); },
        "updatedAt": n => { revisionNoteResponse.updatedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param RevisionNoteUpsertRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRevisionNoteUpsertRequest(revisionNoteUpsertRequest: Partial<RevisionNoteUpsertRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "content": n => { revisionNoteUpsertRequest.content = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param RevisionShareCreateResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRevisionShareCreateResponse(revisionShareCreateResponse: Partial<RevisionShareCreateResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "access": n => { revisionShareCreateResponse.access = n.getStringValue(); },
        "createdAt": n => { revisionShareCreateResponse.createdAt = n.getDateValue(); },
        "expiresAt": n => { revisionShareCreateResponse.expiresAt = n.getDateValue(); },
        "id": n => { revisionShareCreateResponse.id = n.getGuidValue(); },
        "ownerId": n => { revisionShareCreateResponse.ownerId = n.getGuidValue(); },
        "revisionId": n => { revisionShareCreateResponse.revisionId = n.getGuidValue(); },
        "status": n => { revisionShareCreateResponse.status = n.getStringValue(); },
        "token": n => { revisionShareCreateResponse.token = n.getStringValue(); },
        "updatedAt": n => { revisionShareCreateResponse.updatedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param RevisionShareResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoRevisionShareResponse(revisionShareResponse: Partial<RevisionShareResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "access": n => { revisionShareResponse.access = n.getStringValue(); },
        "createdAt": n => { revisionShareResponse.createdAt = n.getDateValue(); },
        "expiresAt": n => { revisionShareResponse.expiresAt = n.getDateValue(); },
        "id": n => { revisionShareResponse.id = n.getGuidValue(); },
        "ownerId": n => { revisionShareResponse.ownerId = n.getGuidValue(); },
        "revisionId": n => { revisionShareResponse.revisionId = n.getGuidValue(); },
        "status": n => { revisionShareResponse.status = n.getStringValue(); },
        "updatedAt": n => { revisionShareResponse.updatedAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param SetDefaultPaymentMethodRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSetDefaultPaymentMethodRequest(setDefaultPaymentMethodRequest: Partial<SetDefaultPaymentMethodRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "paymentMethodId": n => { setDefaultPaymentMethodRequest.paymentMethodId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param SettingsUsageResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSettingsUsageResponse(settingsUsageResponse: Partial<SettingsUsageResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "averageProcessingSeconds": n => { settingsUsageResponse.averageProcessingSeconds = n.getNumberValue(); },
        "completedJobs": n => { settingsUsageResponse.completedJobs = n.getNumberValue(); },
        "completedUploads": n => { settingsUsageResponse.completedUploads = n.getNumberValue(); },
        "endDate": n => { settingsUsageResponse.endDate = n.getDateValue(); },
        "failedJobs": n => { settingsUsageResponse.failedJobs = n.getNumberValue(); },
        "jobRuntimeLimitSeconds": n => { settingsUsageResponse.jobRuntimeLimitSeconds = n.getNumberValue(); },
        "processingSuccessRate": n => { settingsUsageResponse.processingSuccessRate = n.getNumberValue(); },
        "reclaimableTrashBytes": n => { settingsUsageResponse.reclaimableTrashBytes = n.getNumberValue(); },
        "revisionStorageBytes": n => { settingsUsageResponse.revisionStorageBytes = n.getNumberValue(); },
        "startDate": n => { settingsUsageResponse.startDate = n.getDateValue(); },
        "storageBytes": n => { settingsUsageResponse.storageBytes = n.getNumberValue(); },
        "storageLimitBytes": n => { settingsUsageResponse.storageLimitBytes = n.getNumberValue(); },
        "totalJobRuntimeSeconds": n => { settingsUsageResponse.totalJobRuntimeSeconds = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ShareCreateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoShareCreateRequest(shareCreateRequest: Partial<ShareCreateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "access": n => { shareCreateRequest.access = n.getStringValue(); },
        "expiresAt": n => { shareCreateRequest.expiresAt = n.getDateValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param SharedDirectoryResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSharedDirectoryResponse(sharedDirectoryResponse: Partial<SharedDirectoryResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "access": n => { sharedDirectoryResponse.access = n.getStringValue(); },
        "currentDirectory": n => { sharedDirectoryResponse.currentDirectory = n.getObjectValue<DirectoryResponse>(createDirectoryResponseFromDiscriminatorValue); },
        "directories": n => { sharedDirectoryResponse.directories = n.getObjectValue<PaginatedResultOfDirectoryResponse>(createPaginatedResultOfDirectoryResponseFromDiscriminatorValue); },
        "files": n => { sharedDirectoryResponse.files = n.getObjectValue<PaginatedResultOfFileResponse>(createPaginatedResultOfFileResponseFromDiscriminatorValue); },
        "rootDirectoryId": n => { sharedDirectoryResponse.rootDirectoryId = n.getGuidValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param ShareUpdateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoShareUpdateRequest(shareUpdateRequest: Partial<ShareUpdateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "access": n => { shareUpdateRequest.access = n.getStringValue(); },
        "expiresAt": n => { shareUpdateRequest.expiresAt = n.getDateValue(); },
        "status": n => { shareUpdateRequest.status = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param StaticBlurRegionRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoStaticBlurRegionRequest(staticBlurRegionRequest: Partial<StaticBlurRegionRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "endSeconds": n => { staticBlurRegionRequest.endSeconds = n.getNumberValue(); },
        "height": n => { staticBlurRegionRequest.height = n.getNumberValue(); },
        "mode": n => { staticBlurRegionRequest.mode = n.getStringValue(); },
        "startSeconds": n => { staticBlurRegionRequest.startSeconds = n.getNumberValue(); },
        "strength": n => { staticBlurRegionRequest.strength = n.getNumberValue(); },
        "width": n => { staticBlurRegionRequest.width = n.getNumberValue(); },
        "x": n => { staticBlurRegionRequest.x = n.getNumberValue(); },
        "y": n => { staticBlurRegionRequest.y = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param SubscriptionAddonResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSubscriptionAddonResponse(subscriptionAddonResponse: Partial<SubscriptionAddonResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "productId": n => { subscriptionAddonResponse.productId = n.getGuidValue(); },
        "productName": n => { subscriptionAddonResponse.productName = n.getStringValue(); },
        "quantity": n => { subscriptionAddonResponse.quantity = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param SubscriptionResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoSubscriptionResponse(subscriptionResponse: Partial<SubscriptionResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "addons": n => { subscriptionResponse.addons = n.getCollectionOfObjectValues<SubscriptionAddonResponse>(createSubscriptionAddonResponseFromDiscriminatorValue); },
        "cancelAtPeriodEnd": n => { subscriptionResponse.cancelAtPeriodEnd = n.getBooleanValue(); },
        "currentPeriodEnd": n => { subscriptionResponse.currentPeriodEnd = n.getDateValue(); },
        "expiresAt": n => { subscriptionResponse.expiresAt = n.getDateValue(); },
        "externalSubscriptionStatus": n => { subscriptionResponse.externalSubscriptionStatus = n.getStringValue(); },
        "id": n => { subscriptionResponse.id = n.getGuidValue(); },
        "productId": n => { subscriptionResponse.productId = n.getGuidValue(); },
        "productName": n => { subscriptionResponse.productName = n.getStringValue(); },
        "quantity": n => { subscriptionResponse.quantity = n.getNumberValue(); },
        "startsAt": n => { subscriptionResponse.startsAt = n.getDateValue(); },
        "status": n => { subscriptionResponse.status = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param TagCreateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTagCreateRequest(tagCreateRequest: Partial<TagCreateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "name": n => { tagCreateRequest.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param TagResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTagResponse(tagResponse: Partial<TagResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "id": n => { tagResponse.id = n.getGuidValue(); },
        "name": n => { tagResponse.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param TagUpdateRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTagUpdateRequest(tagUpdateRequest: Partial<TagUpdateRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "name": n => { tagUpdateRequest.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param TrashItemResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoTrashItemResponse(trashItemResponse: Partial<TrashItemResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "ancestorDirectoryIds": n => { trashItemResponse.ancestorDirectoryIds = n.getCollectionOfPrimitiveValues<Guid>("string"); },
        "archivedAt": n => { trashItemResponse.archivedAt = n.getDateValue(); },
        "directory": n => { trashItemResponse.directory = n.getObjectValue<DirectoryResponse>(createDirectoryResponseFromDiscriminatorValue); },
        "file": n => { trashItemResponse.file = n.getObjectValue<FileResponse>(createFileResponseFromDiscriminatorValue); },
        "id": n => { trashItemResponse.id = n.getGuidValue(); },
        "kind": n => { trashItemResponse.kind = n.getStringValue(); },
        "revision": n => { trashItemResponse.revision = n.getObjectValue<ArchivedFileRevisionResponse>(createArchivedFileRevisionResponseFromDiscriminatorValue); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateAddonQuantityRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateAddonQuantityRequest(updateAddonQuantityRequest: Partial<UpdateAddonQuantityRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "productId": n => { updateAddonQuantityRequest.productId = n.getGuidValue(); },
        "quantity": n => { updateAddonQuantityRequest.quantity = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateImageWatermarkPresetRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateImageWatermarkPresetRequest(updateImageWatermarkPresetRequest: Partial<UpdateImageWatermarkPresetRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "count": n => { updateImageWatermarkPresetRequest.count = n.getNumberValue(); },
        "name": n => { updateImageWatermarkPresetRequest.name = n.getStringValue(); },
        "opacity": n => { updateImageWatermarkPresetRequest.opacity = n.getNumberValue(); },
        "placementMode": n => { updateImageWatermarkPresetRequest.placementMode = n.getStringValue(); },
        "position": n => { updateImageWatermarkPresetRequest.position = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param UpdateImageWatermarkRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoUpdateImageWatermarkRequest(updateImageWatermarkRequest: Partial<UpdateImageWatermarkRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "name": n => { updateImageWatermarkRequest.name = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param VideoAudioClipRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoVideoAudioClipRequest(videoAudioClipRequest: Partial<VideoAudioClipRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "audioInputId": n => { videoAudioClipRequest.audioInputId = n.getGuidValue(); },
        "sourceEndSeconds": n => { videoAudioClipRequest.sourceEndSeconds = n.getNumberValue(); },
        "sourceStartSeconds": n => { videoAudioClipRequest.sourceStartSeconds = n.getNumberValue(); },
        "videoStartSeconds": n => { videoAudioClipRequest.videoStartSeconds = n.getNumberValue(); },
        "volumePercent": n => { videoAudioClipRequest.volumePercent = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param VideoAudioInputResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoVideoAudioInputResponse(videoAudioInputResponse: Partial<VideoAudioInputResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "contentType": n => { videoAudioInputResponse.contentType = n.getStringValue(); },
        "expiresAt": n => { videoAudioInputResponse.expiresAt = n.getDateValue(); },
        "fileName": n => { videoAudioInputResponse.fileName = n.getStringValue(); },
        "id": n => { videoAudioInputResponse.id = n.getGuidValue(); },
        "size": n => { videoAudioInputResponse.size = n.getNumberValue(); },
        "status": n => { videoAudioInputResponse.status = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param VideoAudioInputUploadResponse The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoVideoAudioInputUploadResponse(videoAudioInputUploadResponse: Partial<VideoAudioInputUploadResponse> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "audioInputId": n => { videoAudioInputUploadResponse.audioInputId = n.getGuidValue(); },
        "expiresAt": n => { videoAudioInputUploadResponse.expiresAt = n.getDateValue(); },
        "partUrls": n => { videoAudioInputUploadResponse.partUrls = n.getCollectionOfObjectValues<PresignedPartUrl>(createPresignedPartUrlFromDiscriminatorValue); },
        "uploadId": n => { videoAudioInputUploadResponse.uploadId = n.getStringValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param VideoTrimSectionRequest The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoVideoTrimSectionRequest(videoTrimSectionRequest: Partial<VideoTrimSectionRequest> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "endSeconds": n => { videoTrimSectionRequest.endSeconds = n.getNumberValue(); },
        "startSeconds": n => { videoTrimSectionRequest.startSeconds = n.getNumberValue(); },
    }
}
/**
 * The deserialization information for the current model
 * @param WatermarkPoint The instance to deserialize into.
 * @returns {Record<string, (node: ParseNode) => void>}
 */
// @ts-ignore
export function deserializeIntoWatermarkPoint(watermarkPoint: Partial<WatermarkPoint> | undefined = {}) : Record<string, (node: ParseNode) => void> {
    return {
        "x": n => { watermarkPoint.x = n.getNumberValue(); },
        "y": n => { watermarkPoint.y = n.getNumberValue(); },
    }
}
export interface DirectoryCopyRequest extends AdditionalDataHolder, Parsable {
    /**
     * The destinationParentDirectoryId property
     */
    destinationParentDirectoryId?: Guid | null;
    /**
     * The name property
     */
    name?: string | null;
}
export interface DirectoryCreateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The isPinned property
     */
    isPinned?: boolean | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The parentDirectoryId property
     */
    parentDirectoryId?: Guid | null;
}
export interface DirectoryMoveRequest extends AdditionalDataHolder, Parsable {
    /**
     * The destinationParentDirectoryId property
     */
    destinationParentDirectoryId?: Guid | null;
}
export interface DirectoryResponse extends AdditionalDataHolder, Parsable {
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The isPinned property
     */
    isPinned?: boolean | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The parentDirectoryId property
     */
    parentDirectoryId?: Guid | null;
    /**
     * The status property
     */
    status?: string | null;
    /**
     * The updatedAt property
     */
    updatedAt?: Date | null;
}
export interface DirectoryShareCreateResponse extends AdditionalDataHolder, Parsable {
    /**
     * The access property
     */
    access?: string | null;
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The directoryId property
     */
    directoryId?: Guid | null;
    /**
     * The expiresAt property
     */
    expiresAt?: Date | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The ownerId property
     */
    ownerId?: Guid | null;
    /**
     * The status property
     */
    status?: string | null;
    /**
     * The token property
     */
    token?: string | null;
    /**
     * The updatedAt property
     */
    updatedAt?: Date | null;
}
export interface DirectoryShareResponse extends AdditionalDataHolder, Parsable {
    /**
     * The access property
     */
    access?: string | null;
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The directoryId property
     */
    directoryId?: Guid | null;
    /**
     * The expiresAt property
     */
    expiresAt?: Date | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The ownerId property
     */
    ownerId?: Guid | null;
    /**
     * The status property
     */
    status?: string | null;
    /**
     * The updatedAt property
     */
    updatedAt?: Date | null;
}
export interface DirectoryUpdateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The isPinned property
     */
    isPinned?: boolean | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The parentDirectoryId property
     */
    parentDirectoryId?: Guid | null;
}
export interface DynamicWatermarkMatchResponse extends AdditionalDataHolder, Parsable {
    /**
     * The algorithmVersion property
     */
    algorithmVersion?: number | null;
    /**
     * The anchorMarked property
     */
    anchorMarked?: boolean | null;
    /**
     * The confidence property
     */
    confidence?: string | null;
    /**
     * The coverage property
     */
    coverage?: number | null;
    /**
     * The expectedCollisions property
     */
    expectedCollisions?: number | null;
    /**
     * The identifier property
     */
    identifier?: string | null;
    /**
     * The jobId property
     */
    jobId?: Guid | null;
    /**
     * The matchedCount property
     */
    matchedCount?: number | null;
    /**
     * The maxDistance property
     */
    maxDistance?: number | null;
    /**
     * The meanDistance property
     */
    meanDistance?: number | null;
    /**
     * The occurrences property
     */
    occurrences?: number | null;
    /**
     * The patternSpace property
     */
    patternSpace?: number | null;
    /**
     * The positions property
     */
    positions?: WatermarkPoint[] | null;
    /**
     * The revisionId property
     */
    revisionId?: Guid | null;
    /**
     * The revisionName property
     */
    revisionName?: string | null;
    /**
     * The watermarkCount property
     */
    watermarkCount?: number | null;
}
export interface EmailSignInRequest extends AdditionalDataHolder, Parsable {
    /**
     * The callbackUrl property
     */
    callbackUrl?: string | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The password property
     */
    password?: string | null;
    /**
     * The rememberMe property
     */
    rememberMe?: boolean | null;
}
export interface EmailSignUpRequest extends AdditionalDataHolder, Parsable {
    /**
     * The callbackUrl property
     */
    callbackUrl?: string | null;
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The image property
     */
    image?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The password property
     */
    password?: string | null;
    /**
     * The rememberMe property
     */
    rememberMe?: boolean | null;
}
export interface FileCopyRequest extends AdditionalDataHolder, Parsable {
    /**
     * The destinationDirectoryId property
     */
    destinationDirectoryId?: Guid | null;
    /**
     * The name property
     */
    name?: string | null;
}
export interface FileDownloadResponse extends AdditionalDataHolder, Parsable {
    /**
     * The url property
     */
    url?: string | null;
}
export interface FileMonthResponse extends AdditionalDataHolder, Parsable {
    /**
     * The count property
     */
    count?: number | null;
    /**
     * The month property
     */
    month?: string | null;
}
export interface FileMoveRequest extends AdditionalDataHolder, Parsable {
    /**
     * The destinationDirectoryId property
     */
    destinationDirectoryId?: Guid | null;
}
export interface FilePreviewGroupedResponse extends AdditionalDataHolder, Parsable {
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The fileId property
     */
    fileId?: Guid | null;
    /**
     * The revisionId property
     */
    revisionId?: Guid | null;
    /**
     * The status property
     */
    status?: string | null;
    /**
     * The updatedAt property
     */
    updatedAt?: Date | null;
    /**
     * The urls property
     */
    urls?: FilePreviewGroupedResponse_urls | null;
}
export interface FilePreviewGroupedResponse_urls extends AdditionalDataHolder, Parsable {
}
export interface FileResponse extends AdditionalDataHolder, Parsable {
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The directoryId property
     */
    directoryId?: Guid | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The latestRevision property
     */
    latestRevision?: FileRevisionResponse | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The ownerId property
     */
    ownerId?: Guid | null;
    /**
     * The revisionCount property
     */
    revisionCount?: number | null;
    /**
     * The status property
     */
    status?: string | null;
    /**
     * The tags property
     */
    tags?: TagResponse[] | null;
    /**
     * The updatedAt property
     */
    updatedAt?: Date | null;
}
export interface FileRevisionResponse extends AdditionalDataHolder, Parsable {
    /**
     * The contentType property
     */
    contentType?: string | null;
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The fileId property
     */
    fileId?: Guid | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The ownerId property
     */
    ownerId?: Guid | null;
    /**
     * The parentRevisionId property
     */
    parentRevisionId?: Guid | null;
    /**
     * The persistance property
     */
    persistance?: string | null;
    /**
     * The previewUrls property
     */
    previewUrls?: FileRevisionResponse_previewUrls | null;
    /**
     * The revisionName property
     */
    revisionName?: string | null;
    /**
     * The size property
     */
    size?: number | null;
    /**
     * The status property
     */
    status?: string | null;
    /**
     * The ttlSeconds property
     */
    ttlSeconds?: number | null;
    /**
     * The type property
     */
    type?: string | null;
}
export interface FileRevisionResponse_previewUrls extends AdditionalDataHolder, Parsable {
}
export interface FileShareCreateResponse extends AdditionalDataHolder, Parsable {
    /**
     * The access property
     */
    access?: string | null;
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The expiresAt property
     */
    expiresAt?: Date | null;
    /**
     * The fileId property
     */
    fileId?: Guid | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The ownerId property
     */
    ownerId?: Guid | null;
    /**
     * The status property
     */
    status?: string | null;
    /**
     * The token property
     */
    token?: string | null;
    /**
     * The updatedAt property
     */
    updatedAt?: Date | null;
}
export interface FileShareResponse extends AdditionalDataHolder, Parsable {
    /**
     * The access property
     */
    access?: string | null;
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The expiresAt property
     */
    expiresAt?: Date | null;
    /**
     * The fileId property
     */
    fileId?: Guid | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The ownerId property
     */
    ownerId?: Guid | null;
    /**
     * The status property
     */
    status?: string | null;
    /**
     * The updatedAt property
     */
    updatedAt?: Date | null;
}
export interface ForgotPasswordRequest extends AdditionalDataHolder, Parsable {
    /**
     * The email property
     */
    email?: string | null;
    /**
     * The redirectTo property
     */
    redirectTo?: string | null;
}
export interface HttpValidationProblemDetails extends AdditionalDataHolder, ApiError, Parsable {
    /**
     * The detail property
     */
    detail?: string | null;
    /**
     * The errors property
     */
    errors?: HttpValidationProblemDetails_errors | null;
    /**
     * The instance property
     */
    instance?: string | null;
    /**
     * The status property
     */
    status?: number | null;
    /**
     * The title property
     */
    title?: string | null;
    /**
     * The type property
     */
    type?: string | null;
}
export interface HttpValidationProblemDetails_errors extends AdditionalDataHolder, Parsable {
}
export interface IdentifyDynamicWatermarkRequest extends AdditionalDataHolder, Parsable {
    /**
     * The fileId property
     */
    fileId?: Guid | null;
    /**
     * The points property
     */
    points?: WatermarkPoint[] | null;
    /**
     * The tolerance property
     */
    tolerance?: number | null;
}
export interface IdentifyDynamicWatermarkResponse extends AdditionalDataHolder, Parsable {
    /**
     * The ambiguous property
     */
    ambiguous?: boolean | null;
    /**
     * The candidatesEvaluated property
     */
    candidatesEvaluated?: number | null;
    /**
     * The matches property
     */
    matches?: DynamicWatermarkMatchResponse[] | null;
    /**
     * The pointsEvaluated property
     */
    pointsEvaluated?: number | null;
    /**
     * The totalMatches property
     */
    totalMatches?: number | null;
    /**
     * The weakPattern property
     */
    weakPattern?: boolean | null;
}
export interface IError extends AdditionalDataHolder, ApiError, Parsable {
    /**
     * The message property
     */
    messageEscaped?: string | null;
}
export interface ImageWatermarkPresetResponse extends AdditionalDataHolder, Parsable {
    /**
     * The count property
     */
    count?: number | null;
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The imageWatermarkId property
     */
    imageWatermarkId?: Guid | null;
    /**
     * The imageWatermarkName property
     */
    imageWatermarkName?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The opacity property
     */
    opacity?: number | null;
    /**
     * The placementMode property
     */
    placementMode?: string | null;
    /**
     * The position property
     */
    position?: string | null;
    /**
     * The status property
     */
    status?: string | null;
    /**
     * The updatedAt property
     */
    updatedAt?: Date | null;
}
export interface ImageWatermarkResponse extends AdditionalDataHolder, Parsable {
    /**
     * The contentType property
     */
    contentType?: string | null;
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The downloadUrl property
     */
    downloadUrl?: string | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The size property
     */
    size?: number | null;
    /**
     * The status property
     */
    status?: string | null;
    /**
     * The updatedAt property
     */
    updatedAt?: Date | null;
}
export interface ImageWatermarkUploadResponse extends AdditionalDataHolder, Parsable {
    /**
     * The expiresAt property
     */
    expiresAt?: Date | null;
    /**
     * The imageWatermarkId property
     */
    imageWatermarkId?: Guid | null;
    /**
     * The partUrls property
     */
    partUrls?: PresignedPartUrl[] | null;
    /**
     * The uploadId property
     */
    uploadId?: string | null;
}
export interface InitiateFileUploadRequest extends AdditionalDataHolder, Parsable {
    /**
     * The contentType property
     */
    contentType?: string | null;
    /**
     * The directoryId property
     */
    directoryId?: Guid | null;
    /**
     * The fileName property
     */
    fileName?: string | null;
    /**
     * The partCount property
     */
    partCount?: number | null;
    /**
     * The partSize property
     */
    partSize?: number | null;
    /**
     * The persistance property
     */
    persistance?: string | null;
    /**
     * The size property
     */
    size?: number | null;
    /**
     * The ttlSeconds property
     */
    ttlSeconds?: number | null;
}
export interface InitiateImageWatermarkUploadRequest extends AdditionalDataHolder, Parsable {
    /**
     * The contentType property
     */
    contentType?: string | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The partCount property
     */
    partCount?: number | null;
    /**
     * The size property
     */
    size?: number | null;
}
export interface InitiateRevisionUploadRequest extends AdditionalDataHolder, Parsable {
    /**
     * The contentType property
     */
    contentType?: string | null;
    /**
     * The parentRevisionId property
     */
    parentRevisionId?: Guid | null;
    /**
     * The partCount property
     */
    partCount?: number | null;
    /**
     * The persistance property
     */
    persistance?: string | null;
    /**
     * The revisionName property
     */
    revisionName?: string | null;
    /**
     * The size property
     */
    size?: number | null;
    /**
     * The ttlSeconds property
     */
    ttlSeconds?: number | null;
}
export interface InitiateVideoAudioInputUploadRequest extends AdditionalDataHolder, Parsable {
    /**
     * The contentType property
     */
    contentType?: string | null;
    /**
     * The fileName property
     */
    fileName?: string | null;
    /**
     * The partCount property
     */
    partCount?: number | null;
    /**
     * The size property
     */
    size?: number | null;
}
export interface JobListResponse extends AdditionalDataHolder, Parsable {
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The fileId property
     */
    fileId?: Guid | null;
    /**
     * The fileName property
     */
    fileName?: string | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The ownerId property
     */
    ownerId?: Guid | null;
    /**
     * The revisionName property
     */
    revisionName?: string | null;
    /**
     * The status property
     */
    status?: string | null;
    /**
     * The statusMessage property
     */
    statusMessage?: string | null;
    /**
     * The type property
     */
    type?: string | null;
    /**
     * The updatedAt property
     */
    updatedAt?: Date | null;
}
export interface JobResponse extends AdditionalDataHolder, Parsable {
    /**
     * The jobId property
     */
    jobId?: Guid | null;
}
export interface JobStatusResponse extends AdditionalDataHolder, Parsable {
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The status property
     */
    status?: string | null;
    /**
     * The statusMessage property
     */
    statusMessage?: string | null;
    /**
     * The type property
     */
    type?: string | null;
    /**
     * The updatedAt property
     */
    updatedAt?: Date | null;
}
export interface MultipartUploadResponse extends AdditionalDataHolder, Parsable {
    /**
     * The expiresAt property
     */
    expiresAt?: Date | null;
    /**
     * The fileId property
     */
    fileId?: Guid | null;
    /**
     * The partSize property
     */
    partSize?: number | null;
    /**
     * The partUrls property
     */
    partUrls?: PresignedPartUrl[] | null;
    /**
     * The revisionId property
     */
    revisionId?: Guid | null;
    /**
     * The uploadId property
     */
    uploadId?: string | null;
}
export interface NotificationResponse extends AdditionalDataHolder, Parsable {
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The isRead property
     */
    isRead?: boolean | null;
    /**
     * The message property
     */
    message?: string | null;
    /**
     * The path property
     */
    path?: string | null;
    /**
     * The userId property
     */
    userId?: Guid | null;
}
export interface PaginatedResultOfArchivedFileRevisionResponse extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: ArchivedFileRevisionResponse[] | null;
    /**
     * The page property
     */
    page?: number | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedResultOfDirectoryResponse extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: DirectoryResponse[] | null;
    /**
     * The page property
     */
    page?: number | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedResultOfDirectoryShareResponse extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: DirectoryShareResponse[] | null;
    /**
     * The page property
     */
    page?: number | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedResultOfFilePreviewGroupedResponse extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: FilePreviewGroupedResponse[] | null;
    /**
     * The page property
     */
    page?: number | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedResultOfFileResponse extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: FileResponse[] | null;
    /**
     * The page property
     */
    page?: number | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedResultOfFileRevisionResponse extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: FileRevisionResponse[] | null;
    /**
     * The page property
     */
    page?: number | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedResultOfFileShareResponse extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: FileShareResponse[] | null;
    /**
     * The page property
     */
    page?: number | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedResultOfImageWatermarkPresetResponse extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: ImageWatermarkPresetResponse[] | null;
    /**
     * The page property
     */
    page?: number | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedResultOfImageWatermarkResponse extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: ImageWatermarkResponse[] | null;
    /**
     * The page property
     */
    page?: number | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedResultOfJobListResponse extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: JobListResponse[] | null;
    /**
     * The page property
     */
    page?: number | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedResultOfNotificationResponse extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: NotificationResponse[] | null;
    /**
     * The page property
     */
    page?: number | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedResultOfPendingFileResponse extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: PendingFileResponse[] | null;
    /**
     * The page property
     */
    page?: number | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedResultOfPendingRevisionResponse extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: PendingRevisionResponse[] | null;
    /**
     * The page property
     */
    page?: number | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedResultOfRevisionCommentResponse extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: RevisionCommentResponse[] | null;
    /**
     * The page property
     */
    page?: number | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedResultOfRevisionShareResponse extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: RevisionShareResponse[] | null;
    /**
     * The page property
     */
    page?: number | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedResultOfTagResponse extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: TagResponse[] | null;
    /**
     * The page property
     */
    page?: number | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaginatedResultOfTrashItemResponse extends AdditionalDataHolder, Parsable {
    /**
     * The hasNextPage property
     */
    hasNextPage?: boolean | null;
    /**
     * The hasPreviousPage property
     */
    hasPreviousPage?: boolean | null;
    /**
     * The items property
     */
    items?: TrashItemResponse[] | null;
    /**
     * The page property
     */
    page?: number | null;
    /**
     * The pageSize property
     */
    pageSize?: number | null;
    /**
     * The totalCount property
     */
    totalCount?: number | null;
    /**
     * The totalPages property
     */
    totalPages?: number | null;
}
export interface PaymentMethodResponse extends AdditionalDataHolder, Parsable {
    /**
     * The brand property
     */
    brand?: string | null;
    /**
     * The expMonth property
     */
    expMonth?: number | null;
    /**
     * The expYear property
     */
    expYear?: number | null;
    /**
     * The id property
     */
    id?: string | null;
    /**
     * The isDefault property
     */
    isDefault?: boolean | null;
    /**
     * The last4 property
     */
    last4?: string | null;
}
export interface PendingFileResponse extends AdditionalDataHolder, Parsable {
    /**
     * The contentType property
     */
    contentType?: string | null;
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The directoryId property
     */
    directoryId?: Guid | null;
    /**
     * The extUploadId property
     */
    extUploadId?: string | null;
    /**
     * The fileId property
     */
    fileId?: Guid | null;
    /**
     * The fileName property
     */
    fileName?: string | null;
    /**
     * The persistance property
     */
    persistance?: string | null;
    /**
     * The revisionId property
     */
    revisionId?: Guid | null;
    /**
     * The size property
     */
    size?: number | null;
    /**
     * The ttlSeconds property
     */
    ttlSeconds?: number | null;
}
export interface PendingRevisionResponse extends AdditionalDataHolder, Parsable {
    /**
     * The contentType property
     */
    contentType?: string | null;
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The extUploadId property
     */
    extUploadId?: string | null;
    /**
     * The fileId property
     */
    fileId?: Guid | null;
    /**
     * The fileName property
     */
    fileName?: string | null;
    /**
     * The persistance property
     */
    persistance?: string | null;
    /**
     * The revisionId property
     */
    revisionId?: Guid | null;
    /**
     * The revisionName property
     */
    revisionName?: string | null;
    /**
     * The size property
     */
    size?: number | null;
    /**
     * The ttlSeconds property
     */
    ttlSeconds?: number | null;
}
export interface PresignedPartUrl extends AdditionalDataHolder, Parsable {
    /**
     * The partNumber property
     */
    partNumber?: number | null;
    /**
     * The url property
     */
    url?: string | null;
}
export interface ResetPasswordRequest extends AdditionalDataHolder, Parsable {
    /**
     * The newPassword property
     */
    newPassword?: string | null;
    /**
     * The token property
     */
    token?: string | null;
}
export interface ResumeUploadRequest extends AdditionalDataHolder, Parsable {
    /**
     * The partCount property
     */
    partCount?: number | null;
    /**
     * The partSize property
     */
    partSize?: number | null;
}
export interface RevisionCommentCreateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The content property
     */
    content?: string | null;
    /**
     * The mentions property
     */
    mentions?: RevisionCommentMentionDto[] | null;
}
export interface RevisionCommentMentionDto extends AdditionalDataHolder, Parsable {
    /**
     * The length property
     */
    length?: number | null;
    /**
     * The start property
     */
    start?: number | null;
    /**
     * The userId property
     */
    userId?: Guid | null;
}
export interface RevisionCommentResponse extends AdditionalDataHolder, Parsable {
    /**
     * The authorId property
     */
    authorId?: Guid | null;
    /**
     * The content property
     */
    content?: string | null;
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The mentions property
     */
    mentions?: RevisionCommentMentionDto[] | null;
    /**
     * The revisionId property
     */
    revisionId?: Guid | null;
    /**
     * The status property
     */
    status?: string | null;
    /**
     * The updatedAt property
     */
    updatedAt?: Date | null;
}
export interface RevisionCommentUpdateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The content property
     */
    content?: string | null;
    /**
     * The mentions property
     */
    mentions?: RevisionCommentMentionDto[] | null;
}
export interface RevisionNoteResponse extends AdditionalDataHolder, Parsable {
    /**
     * The content property
     */
    content?: string | null;
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The revisionId property
     */
    revisionId?: Guid | null;
    /**
     * The status property
     */
    status?: string | null;
    /**
     * The updatedAt property
     */
    updatedAt?: Date | null;
}
export interface RevisionNoteUpsertRequest extends AdditionalDataHolder, Parsable {
    /**
     * The content property
     */
    content?: string | null;
}
export interface RevisionShareCreateResponse extends AdditionalDataHolder, Parsable {
    /**
     * The access property
     */
    access?: string | null;
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The expiresAt property
     */
    expiresAt?: Date | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The ownerId property
     */
    ownerId?: Guid | null;
    /**
     * The revisionId property
     */
    revisionId?: Guid | null;
    /**
     * The status property
     */
    status?: string | null;
    /**
     * The token property
     */
    token?: string | null;
    /**
     * The updatedAt property
     */
    updatedAt?: Date | null;
}
export interface RevisionShareResponse extends AdditionalDataHolder, Parsable {
    /**
     * The access property
     */
    access?: string | null;
    /**
     * The createdAt property
     */
    createdAt?: Date | null;
    /**
     * The expiresAt property
     */
    expiresAt?: Date | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The ownerId property
     */
    ownerId?: Guid | null;
    /**
     * The revisionId property
     */
    revisionId?: Guid | null;
    /**
     * The status property
     */
    status?: string | null;
    /**
     * The updatedAt property
     */
    updatedAt?: Date | null;
}
/**
 * Serializes information the current object
 * @param AbortUploadRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAbortUploadRequest(writer: SerializationWriter, abortUploadRequest: Partial<AbortUploadRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!abortUploadRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("uploadId", abortUploadRequest.uploadId);
    writer.writeAdditionalData(abortUploadRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param AddonQuantityRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAddonQuantityRequest(writer: SerializationWriter, addonQuantityRequest: Partial<AddonQuantityRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!addonQuantityRequest || isSerializingDerivedType) { return; }
    writer.writeGuidValue("productId", addonQuantityRequest.productId);
    writer.writeNumberValue("quantity", addonQuantityRequest.quantity);
    writer.writeAdditionalData(addonQuantityRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param ArchivedFileRevisionResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeArchivedFileRevisionResponse(writer: SerializationWriter, archivedFileRevisionResponse: Partial<ArchivedFileRevisionResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!archivedFileRevisionResponse || isSerializingDerivedType) { return; }
    writer.writeStringValue("contentType", archivedFileRevisionResponse.contentType);
    writer.writeDateValue("createdAt", archivedFileRevisionResponse.createdAt);
    writer.writeGuidValue("directoryId", archivedFileRevisionResponse.directoryId);
    writer.writeGuidValue("fileId", archivedFileRevisionResponse.fileId);
    writer.writeStringValue("fileName", archivedFileRevisionResponse.fileName);
    writer.writeGuidValue("id", archivedFileRevisionResponse.id);
    writer.writeGuidValue("ownerId", archivedFileRevisionResponse.ownerId);
    writer.writeGuidValue("parentRevisionId", archivedFileRevisionResponse.parentRevisionId);
    writer.writeStringValue("persistance", archivedFileRevisionResponse.persistance);
    writer.writeObjectValue<ArchivedFileRevisionResponse_previewUrls>("previewUrls", archivedFileRevisionResponse.previewUrls, serializeArchivedFileRevisionResponse_previewUrls);
    writer.writeStringValue("revisionName", archivedFileRevisionResponse.revisionName);
    writer.writeNumberValue("size", archivedFileRevisionResponse.size);
    writer.writeStringValue("status", archivedFileRevisionResponse.status);
    writer.writeNumberValue("ttlSeconds", archivedFileRevisionResponse.ttlSeconds);
    writer.writeStringValue("type", archivedFileRevisionResponse.type);
    writer.writeAdditionalData(archivedFileRevisionResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param ArchivedFileRevisionResponse_previewUrls The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeArchivedFileRevisionResponse_previewUrls(writer: SerializationWriter, archivedFileRevisionResponse_previewUrls: Partial<ArchivedFileRevisionResponse_previewUrls> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!archivedFileRevisionResponse_previewUrls || isSerializingDerivedType) { return; }
    writer.writeAdditionalData(archivedFileRevisionResponse_previewUrls.additionalData);
}
/**
 * Serializes information the current object
 * @param AudioMuteRangeRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeAudioMuteRangeRequest(writer: SerializationWriter, audioMuteRangeRequest: Partial<AudioMuteRangeRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!audioMuteRangeRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("endSeconds", audioMuteRangeRequest.endSeconds);
    writer.writeNumberValue("startSeconds", audioMuteRangeRequest.startSeconds);
    writer.writeAdditionalData(audioMuteRangeRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param BillingProductResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeBillingProductResponse(writer: SerializationWriter, billingProductResponse: Partial<BillingProductResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!billingProductResponse || isSerializingDerivedType) { return; }
    writer.writeStringValue("billingInterval", billingProductResponse.billingInterval);
    writer.writeStringValue("currency", billingProductResponse.currency);
    writer.writeStringValue("description", billingProductResponse.description);
    writer.writeGuidValue("id", billingProductResponse.id);
    writer.writeBooleanValue("isAddon", billingProductResponse.isAddon);
    writer.writeNumberValue("jobRuntimeSeconds", billingProductResponse.jobRuntimeSeconds);
    writer.writeStringValue("name", billingProductResponse.name);
    writer.writeNumberValue("priceAmount", billingProductResponse.priceAmount);
    writer.writeNumberValue("storageBytes", billingProductResponse.storageBytes);
    writer.writeAdditionalData(billingProductResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param CancelSubscriptionRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCancelSubscriptionRequest(writer: SerializationWriter, cancelSubscriptionRequest: Partial<CancelSubscriptionRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!cancelSubscriptionRequest || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("immediately", cancelSubscriptionRequest.immediately ?? false);
    writer.writeAdditionalData(cancelSubscriptionRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param ChangePlanRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeChangePlanRequest(writer: SerializationWriter, changePlanRequest: Partial<ChangePlanRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!changePlanRequest || isSerializingDerivedType) { return; }
    writer.writeGuidValue("productId", changePlanRequest.productId);
    writer.writeAdditionalData(changePlanRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param CompletedPartInfo The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCompletedPartInfo(writer: SerializationWriter, completedPartInfo: Partial<CompletedPartInfo> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!completedPartInfo || isSerializingDerivedType) { return; }
    writer.writeStringValue("eTag", completedPartInfo.eTag);
    writer.writeNumberValue("partNumber", completedPartInfo.partNumber);
    writer.writeAdditionalData(completedPartInfo.additionalData);
}
/**
 * Serializes information the current object
 * @param CompleteUploadRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCompleteUploadRequest(writer: SerializationWriter, completeUploadRequest: Partial<CompleteUploadRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!completeUploadRequest || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<CompletedPartInfo>("parts", completeUploadRequest.parts, serializeCompletedPartInfo);
    writer.writeStringValue("uploadId", completeUploadRequest.uploadId);
    writer.writeAdditionalData(completeUploadRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateCheckoutSessionRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateCheckoutSessionRequest(writer: SerializationWriter, createCheckoutSessionRequest: Partial<CreateCheckoutSessionRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createCheckoutSessionRequest || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<AddonQuantityRequest>("addons", createCheckoutSessionRequest.addons, serializeAddonQuantityRequest);
    writer.writeGuidValue("productId", createCheckoutSessionRequest.productId);
    writer.writeAdditionalData(createCheckoutSessionRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateCheckoutSessionResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateCheckoutSessionResponse(writer: SerializationWriter, createCheckoutSessionResponse: Partial<CreateCheckoutSessionResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createCheckoutSessionResponse || isSerializingDerivedType) { return; }
    writer.writeStringValue("clientSecret", createCheckoutSessionResponse.clientSecret);
    writer.writeStringValue("sessionId", createCheckoutSessionResponse.sessionId);
    writer.writeAdditionalData(createCheckoutSessionResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateDynamicWatermarkJobRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateDynamicWatermarkJobRequest(writer: SerializationWriter, createDynamicWatermarkJobRequest: Partial<CreateDynamicWatermarkJobRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createDynamicWatermarkJobRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("count", createDynamicWatermarkJobRequest.count);
    writer.writeGuidValue("fileId", createDynamicWatermarkJobRequest.fileId);
    writer.writeStringValue("filename", createDynamicWatermarkJobRequest.filename);
    writer.writeNumberValue("fontSize", createDynamicWatermarkJobRequest.fontSize);
    writer.writeCollectionOfPrimitiveValues<string>("identifiers", createDynamicWatermarkJobRequest.identifiers);
    writer.writeNumberValue("opacity", createDynamicWatermarkJobRequest.opacity);
    writer.writeStringValue("position", createDynamicWatermarkJobRequest.position);
    writer.writeGuidValue("revisionId", createDynamicWatermarkJobRequest.revisionId);
    writer.writeStringValue("watermarkText", createDynamicWatermarkJobRequest.watermarkText);
    writer.writeAdditionalData(createDynamicWatermarkJobRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateFaceBlurJobRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateFaceBlurJobRequest(writer: SerializationWriter, createFaceBlurJobRequest: Partial<CreateFaceBlurJobRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createFaceBlurJobRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("detectionFps", createFaceBlurJobRequest.detectionFps);
    writer.writeStringValue("filename", createFaceBlurJobRequest.filename);
    writer.writeNumberValue("minConfidence", createFaceBlurJobRequest.minConfidence);
    writer.writeStringValue("mode", createFaceBlurJobRequest.mode);
    writer.writeNumberValue("padding", createFaceBlurJobRequest.padding);
    writer.writeStringValue("shape", createFaceBlurJobRequest.shape);
    writer.writeNumberValue("strength", createFaceBlurJobRequest.strength);
    writer.writeAdditionalData(createFaceBlurJobRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateFileFromRevisionRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateFileFromRevisionRequest(writer: SerializationWriter, createFileFromRevisionRequest: Partial<CreateFileFromRevisionRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createFileFromRevisionRequest || isSerializingDerivedType) { return; }
    writer.writeGuidValue("destinationDirectoryId", createFileFromRevisionRequest.destinationDirectoryId);
    writer.writeStringValue("name", createFileFromRevisionRequest.name);
    writer.writeStringValue("revisionName", createFileFromRevisionRequest.revisionName);
    writer.writeAdditionalData(createFileFromRevisionRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateFilePreviewJobRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateFilePreviewJobRequest(writer: SerializationWriter, createFilePreviewJobRequest: Partial<CreateFilePreviewJobRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createFilePreviewJobRequest || isSerializingDerivedType) { return; }
    writer.writeGuidValue("fileId", createFilePreviewJobRequest.fileId);
    writer.writeGuidValue("revisionId", createFilePreviewJobRequest.revisionId);
    writer.writeAdditionalData(createFilePreviewJobRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateImageCropJobRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateImageCropJobRequest(writer: SerializationWriter, createImageCropJobRequest: Partial<CreateImageCropJobRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createImageCropJobRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("filename", createImageCropJobRequest.filename);
    writer.writeNumberValue("height", createImageCropJobRequest.height);
    writer.writeNumberValue("width", createImageCropJobRequest.width);
    writer.writeNumberValue("x", createImageCropJobRequest.x);
    writer.writeNumberValue("y", createImageCropJobRequest.y);
    writer.writeAdditionalData(createImageCropJobRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateImageWatermarkPresetRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateImageWatermarkPresetRequest(writer: SerializationWriter, createImageWatermarkPresetRequest: Partial<CreateImageWatermarkPresetRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createImageWatermarkPresetRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("count", createImageWatermarkPresetRequest.count);
    writer.writeGuidValue("imageWatermarkId", createImageWatermarkPresetRequest.imageWatermarkId);
    writer.writeStringValue("name", createImageWatermarkPresetRequest.name);
    writer.writeNumberValue("opacity", createImageWatermarkPresetRequest.opacity);
    writer.writeStringValue("placementMode", createImageWatermarkPresetRequest.placementMode);
    writer.writeStringValue("position", createImageWatermarkPresetRequest.position);
    writer.writeAdditionalData(createImageWatermarkPresetRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateNotificationRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateNotificationRequest(writer: SerializationWriter, createNotificationRequest: Partial<CreateNotificationRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createNotificationRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("message", createNotificationRequest.message);
    writer.writeStringValue("path", createNotificationRequest.path);
    writer.writeAdditionalData(createNotificationRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateRemoveAudioJobRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateRemoveAudioJobRequest(writer: SerializationWriter, createRemoveAudioJobRequest: Partial<CreateRemoveAudioJobRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createRemoveAudioJobRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("filename", createRemoveAudioJobRequest.filename);
    writer.writeCollectionOfObjectValues<AudioMuteRangeRequest>("ranges", createRemoveAudioJobRequest.ranges, serializeAudioMuteRangeRequest);
    writer.writeAdditionalData(createRemoveAudioJobRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateRotateJobRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateRotateJobRequest(writer: SerializationWriter, createRotateJobRequest: Partial<CreateRotateJobRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createRotateJobRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("degrees", createRotateJobRequest.degrees);
    writer.writeStringValue("filename", createRotateJobRequest.filename);
    writer.writeAdditionalData(createRotateJobRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateSetupIntentResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateSetupIntentResponse(writer: SerializationWriter, createSetupIntentResponse: Partial<CreateSetupIntentResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createSetupIntentResponse || isSerializingDerivedType) { return; }
    writer.writeStringValue("clientSecret", createSetupIntentResponse.clientSecret);
    writer.writeStringValue("setupIntentId", createSetupIntentResponse.setupIntentId);
    writer.writeAdditionalData(createSetupIntentResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateStaticBlurJobRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateStaticBlurJobRequest(writer: SerializationWriter, createStaticBlurJobRequest: Partial<CreateStaticBlurJobRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createStaticBlurJobRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("filename", createStaticBlurJobRequest.filename);
    writer.writeCollectionOfObjectValues<StaticBlurRegionRequest>("regions", createStaticBlurJobRequest.regions, serializeStaticBlurRegionRequest);
    writer.writeAdditionalData(createStaticBlurJobRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateTranscodingJobRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateTranscodingJobRequest(writer: SerializationWriter, createTranscodingJobRequest: Partial<CreateTranscodingJobRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createTranscodingJobRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("bitrate", createTranscodingJobRequest.bitrate);
    writer.writeGuidValue("fileId", createTranscodingJobRequest.fileId);
    writer.writeStringValue("filename", createTranscodingJobRequest.filename);
    writer.writeStringValue("resolution", createTranscodingJobRequest.resolution);
    writer.writeGuidValue("revisionId", createTranscodingJobRequest.revisionId);
    writer.writeAdditionalData(createTranscodingJobRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateVideoAudioEditJobRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateVideoAudioEditJobRequest(writer: SerializationWriter, createVideoAudioEditJobRequest: Partial<CreateVideoAudioEditJobRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createVideoAudioEditJobRequest || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<VideoAudioClipRequest>("clips", createVideoAudioEditJobRequest.clips, serializeVideoAudioClipRequest);
    writer.writeStringValue("filename", createVideoAudioEditJobRequest.filename);
    writer.writeStringValue("mode", createVideoAudioEditJobRequest.mode);
    writer.writeAdditionalData(createVideoAudioEditJobRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateVideoScreenshotJobRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateVideoScreenshotJobRequest(writer: SerializationWriter, createVideoScreenshotJobRequest: Partial<CreateVideoScreenshotJobRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createVideoScreenshotJobRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("filename", createVideoScreenshotJobRequest.filename);
    writer.writeStringValue("mode", createVideoScreenshotJobRequest.mode);
    writer.writeNumberValue("timestampSeconds", createVideoScreenshotJobRequest.timestampSeconds);
    writer.writeAdditionalData(createVideoScreenshotJobRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateVideoTrimJobRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateVideoTrimJobRequest(writer: SerializationWriter, createVideoTrimJobRequest: Partial<CreateVideoTrimJobRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createVideoTrimJobRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("endSeconds", createVideoTrimJobRequest.endSeconds);
    writer.writeStringValue("filename", createVideoTrimJobRequest.filename);
    writer.writeCollectionOfObjectValues<VideoTrimSectionRequest>("sections", createVideoTrimJobRequest.sections, serializeVideoTrimSectionRequest);
    writer.writeNumberValue("startSeconds", createVideoTrimJobRequest.startSeconds);
    writer.writeAdditionalData(createVideoTrimJobRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param CreateWatermarkJobRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeCreateWatermarkJobRequest(writer: SerializationWriter, createWatermarkJobRequest: Partial<CreateWatermarkJobRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!createWatermarkJobRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("count", createWatermarkJobRequest.count);
    writer.writeGuidValue("fileId", createWatermarkJobRequest.fileId);
    writer.writeStringValue("filename", createWatermarkJobRequest.filename);
    writer.writeNumberValue("fontSize", createWatermarkJobRequest.fontSize);
    writer.writeNumberValue("opacity", createWatermarkJobRequest.opacity);
    writer.writeStringValue("position", createWatermarkJobRequest.position);
    writer.writeGuidValue("presetId", createWatermarkJobRequest.presetId);
    writer.writeGuidValue("revisionId", createWatermarkJobRequest.revisionId);
    writer.writeStringValue("text", createWatermarkJobRequest.text);
    writer.writeAdditionalData(createWatermarkJobRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param DirectoryCopyRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDirectoryCopyRequest(writer: SerializationWriter, directoryCopyRequest: Partial<DirectoryCopyRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!directoryCopyRequest || isSerializingDerivedType) { return; }
    writer.writeGuidValue("destinationParentDirectoryId", directoryCopyRequest.destinationParentDirectoryId);
    writer.writeStringValue("name", directoryCopyRequest.name);
    writer.writeAdditionalData(directoryCopyRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param DirectoryCreateRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDirectoryCreateRequest(writer: SerializationWriter, directoryCreateRequest: Partial<DirectoryCreateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!directoryCreateRequest || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("isPinned", directoryCreateRequest.isPinned);
    writer.writeStringValue("name", directoryCreateRequest.name);
    writer.writeGuidValue("parentDirectoryId", directoryCreateRequest.parentDirectoryId);
    writer.writeAdditionalData(directoryCreateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param DirectoryMoveRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDirectoryMoveRequest(writer: SerializationWriter, directoryMoveRequest: Partial<DirectoryMoveRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!directoryMoveRequest || isSerializingDerivedType) { return; }
    writer.writeGuidValue("destinationParentDirectoryId", directoryMoveRequest.destinationParentDirectoryId);
    writer.writeAdditionalData(directoryMoveRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param DirectoryResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDirectoryResponse(writer: SerializationWriter, directoryResponse: Partial<DirectoryResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!directoryResponse || isSerializingDerivedType) { return; }
    writer.writeDateValue("createdAt", directoryResponse.createdAt);
    writer.writeGuidValue("id", directoryResponse.id);
    writer.writeBooleanValue("isPinned", directoryResponse.isPinned);
    writer.writeStringValue("name", directoryResponse.name);
    writer.writeGuidValue("parentDirectoryId", directoryResponse.parentDirectoryId);
    writer.writeStringValue("status", directoryResponse.status);
    writer.writeDateValue("updatedAt", directoryResponse.updatedAt);
    writer.writeAdditionalData(directoryResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param DirectoryShareCreateResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDirectoryShareCreateResponse(writer: SerializationWriter, directoryShareCreateResponse: Partial<DirectoryShareCreateResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!directoryShareCreateResponse || isSerializingDerivedType) { return; }
    writer.writeStringValue("access", directoryShareCreateResponse.access);
    writer.writeDateValue("createdAt", directoryShareCreateResponse.createdAt);
    writer.writeGuidValue("directoryId", directoryShareCreateResponse.directoryId);
    writer.writeDateValue("expiresAt", directoryShareCreateResponse.expiresAt);
    writer.writeGuidValue("id", directoryShareCreateResponse.id);
    writer.writeGuidValue("ownerId", directoryShareCreateResponse.ownerId);
    writer.writeStringValue("status", directoryShareCreateResponse.status);
    writer.writeStringValue("token", directoryShareCreateResponse.token);
    writer.writeDateValue("updatedAt", directoryShareCreateResponse.updatedAt);
    writer.writeAdditionalData(directoryShareCreateResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param DirectoryShareResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDirectoryShareResponse(writer: SerializationWriter, directoryShareResponse: Partial<DirectoryShareResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!directoryShareResponse || isSerializingDerivedType) { return; }
    writer.writeStringValue("access", directoryShareResponse.access);
    writer.writeDateValue("createdAt", directoryShareResponse.createdAt);
    writer.writeGuidValue("directoryId", directoryShareResponse.directoryId);
    writer.writeDateValue("expiresAt", directoryShareResponse.expiresAt);
    writer.writeGuidValue("id", directoryShareResponse.id);
    writer.writeGuidValue("ownerId", directoryShareResponse.ownerId);
    writer.writeStringValue("status", directoryShareResponse.status);
    writer.writeDateValue("updatedAt", directoryShareResponse.updatedAt);
    writer.writeAdditionalData(directoryShareResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param DirectoryUpdateRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDirectoryUpdateRequest(writer: SerializationWriter, directoryUpdateRequest: Partial<DirectoryUpdateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!directoryUpdateRequest || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("isPinned", directoryUpdateRequest.isPinned);
    writer.writeStringValue("name", directoryUpdateRequest.name);
    writer.writeGuidValue("parentDirectoryId", directoryUpdateRequest.parentDirectoryId);
    writer.writeAdditionalData(directoryUpdateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param DynamicWatermarkMatchResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeDynamicWatermarkMatchResponse(writer: SerializationWriter, dynamicWatermarkMatchResponse: Partial<DynamicWatermarkMatchResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!dynamicWatermarkMatchResponse || isSerializingDerivedType) { return; }
    writer.writeNumberValue("algorithmVersion", dynamicWatermarkMatchResponse.algorithmVersion);
    writer.writeBooleanValue("anchorMarked", dynamicWatermarkMatchResponse.anchorMarked);
    writer.writeStringValue("confidence", dynamicWatermarkMatchResponse.confidence);
    writer.writeNumberValue("coverage", dynamicWatermarkMatchResponse.coverage);
    writer.writeNumberValue("expectedCollisions", dynamicWatermarkMatchResponse.expectedCollisions);
    writer.writeStringValue("identifier", dynamicWatermarkMatchResponse.identifier);
    writer.writeGuidValue("jobId", dynamicWatermarkMatchResponse.jobId);
    writer.writeNumberValue("matchedCount", dynamicWatermarkMatchResponse.matchedCount);
    writer.writeNumberValue("maxDistance", dynamicWatermarkMatchResponse.maxDistance);
    writer.writeNumberValue("meanDistance", dynamicWatermarkMatchResponse.meanDistance);
    writer.writeNumberValue("occurrences", dynamicWatermarkMatchResponse.occurrences);
    writer.writeNumberValue("patternSpace", dynamicWatermarkMatchResponse.patternSpace);
    writer.writeCollectionOfObjectValues<WatermarkPoint>("positions", dynamicWatermarkMatchResponse.positions, serializeWatermarkPoint);
    writer.writeGuidValue("revisionId", dynamicWatermarkMatchResponse.revisionId);
    writer.writeStringValue("revisionName", dynamicWatermarkMatchResponse.revisionName);
    writer.writeNumberValue("watermarkCount", dynamicWatermarkMatchResponse.watermarkCount);
    writer.writeAdditionalData(dynamicWatermarkMatchResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param EmailSignInRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeEmailSignInRequest(writer: SerializationWriter, emailSignInRequest: Partial<EmailSignInRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!emailSignInRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("callbackUrl", emailSignInRequest.callbackUrl);
    writer.writeStringValue("email", emailSignInRequest.email);
    writer.writeStringValue("password", emailSignInRequest.password);
    writer.writeBooleanValue("rememberMe", emailSignInRequest.rememberMe);
    writer.writeAdditionalData(emailSignInRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param EmailSignUpRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeEmailSignUpRequest(writer: SerializationWriter, emailSignUpRequest: Partial<EmailSignUpRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!emailSignUpRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("callbackUrl", emailSignUpRequest.callbackUrl);
    writer.writeStringValue("email", emailSignUpRequest.email);
    writer.writeStringValue("image", emailSignUpRequest.image);
    writer.writeStringValue("name", emailSignUpRequest.name);
    writer.writeStringValue("password", emailSignUpRequest.password);
    writer.writeBooleanValue("rememberMe", emailSignUpRequest.rememberMe);
    writer.writeAdditionalData(emailSignUpRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param FileCopyRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFileCopyRequest(writer: SerializationWriter, fileCopyRequest: Partial<FileCopyRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!fileCopyRequest || isSerializingDerivedType) { return; }
    writer.writeGuidValue("destinationDirectoryId", fileCopyRequest.destinationDirectoryId);
    writer.writeStringValue("name", fileCopyRequest.name);
    writer.writeAdditionalData(fileCopyRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param FileDownloadResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFileDownloadResponse(writer: SerializationWriter, fileDownloadResponse: Partial<FileDownloadResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!fileDownloadResponse || isSerializingDerivedType) { return; }
    writer.writeStringValue("url", fileDownloadResponse.url);
    writer.writeAdditionalData(fileDownloadResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param FileMonthResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFileMonthResponse(writer: SerializationWriter, fileMonthResponse: Partial<FileMonthResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!fileMonthResponse || isSerializingDerivedType) { return; }
    writer.writeNumberValue("count", fileMonthResponse.count);
    writer.writeStringValue("month", fileMonthResponse.month);
    writer.writeAdditionalData(fileMonthResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param FileMoveRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFileMoveRequest(writer: SerializationWriter, fileMoveRequest: Partial<FileMoveRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!fileMoveRequest || isSerializingDerivedType) { return; }
    writer.writeGuidValue("destinationDirectoryId", fileMoveRequest.destinationDirectoryId);
    writer.writeAdditionalData(fileMoveRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param FilePreviewGroupedResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFilePreviewGroupedResponse(writer: SerializationWriter, filePreviewGroupedResponse: Partial<FilePreviewGroupedResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!filePreviewGroupedResponse || isSerializingDerivedType) { return; }
    writer.writeDateValue("createdAt", filePreviewGroupedResponse.createdAt);
    writer.writeGuidValue("fileId", filePreviewGroupedResponse.fileId);
    writer.writeGuidValue("revisionId", filePreviewGroupedResponse.revisionId);
    writer.writeStringValue("status", filePreviewGroupedResponse.status);
    writer.writeDateValue("updatedAt", filePreviewGroupedResponse.updatedAt);
    writer.writeObjectValue<FilePreviewGroupedResponse_urls>("urls", filePreviewGroupedResponse.urls, serializeFilePreviewGroupedResponse_urls);
    writer.writeAdditionalData(filePreviewGroupedResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param FilePreviewGroupedResponse_urls The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFilePreviewGroupedResponse_urls(writer: SerializationWriter, filePreviewGroupedResponse_urls: Partial<FilePreviewGroupedResponse_urls> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!filePreviewGroupedResponse_urls || isSerializingDerivedType) { return; }
    writer.writeAdditionalData(filePreviewGroupedResponse_urls.additionalData);
}
/**
 * Serializes information the current object
 * @param FileResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFileResponse(writer: SerializationWriter, fileResponse: Partial<FileResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!fileResponse || isSerializingDerivedType) { return; }
    writer.writeDateValue("createdAt", fileResponse.createdAt);
    writer.writeGuidValue("directoryId", fileResponse.directoryId);
    writer.writeGuidValue("id", fileResponse.id);
    writer.writeObjectValue<FileRevisionResponse>("latestRevision", fileResponse.latestRevision, serializeFileRevisionResponse);
    writer.writeStringValue("name", fileResponse.name);
    writer.writeGuidValue("ownerId", fileResponse.ownerId);
    writer.writeNumberValue("revisionCount", fileResponse.revisionCount);
    writer.writeStringValue("status", fileResponse.status);
    writer.writeCollectionOfObjectValues<TagResponse>("tags", fileResponse.tags, serializeTagResponse);
    writer.writeDateValue("updatedAt", fileResponse.updatedAt);
    writer.writeAdditionalData(fileResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param FileRevisionResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFileRevisionResponse(writer: SerializationWriter, fileRevisionResponse: Partial<FileRevisionResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!fileRevisionResponse || isSerializingDerivedType) { return; }
    writer.writeStringValue("contentType", fileRevisionResponse.contentType);
    writer.writeDateValue("createdAt", fileRevisionResponse.createdAt);
    writer.writeGuidValue("fileId", fileRevisionResponse.fileId);
    writer.writeGuidValue("id", fileRevisionResponse.id);
    writer.writeGuidValue("ownerId", fileRevisionResponse.ownerId);
    writer.writeGuidValue("parentRevisionId", fileRevisionResponse.parentRevisionId);
    writer.writeStringValue("persistance", fileRevisionResponse.persistance);
    writer.writeObjectValue<FileRevisionResponse_previewUrls>("previewUrls", fileRevisionResponse.previewUrls, serializeFileRevisionResponse_previewUrls);
    writer.writeStringValue("revisionName", fileRevisionResponse.revisionName);
    writer.writeNumberValue("size", fileRevisionResponse.size);
    writer.writeStringValue("status", fileRevisionResponse.status);
    writer.writeNumberValue("ttlSeconds", fileRevisionResponse.ttlSeconds);
    writer.writeStringValue("type", fileRevisionResponse.type);
    writer.writeAdditionalData(fileRevisionResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param FileRevisionResponse_previewUrls The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFileRevisionResponse_previewUrls(writer: SerializationWriter, fileRevisionResponse_previewUrls: Partial<FileRevisionResponse_previewUrls> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!fileRevisionResponse_previewUrls || isSerializingDerivedType) { return; }
    writer.writeAdditionalData(fileRevisionResponse_previewUrls.additionalData);
}
/**
 * Serializes information the current object
 * @param FileShareCreateResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFileShareCreateResponse(writer: SerializationWriter, fileShareCreateResponse: Partial<FileShareCreateResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!fileShareCreateResponse || isSerializingDerivedType) { return; }
    writer.writeStringValue("access", fileShareCreateResponse.access);
    writer.writeDateValue("createdAt", fileShareCreateResponse.createdAt);
    writer.writeDateValue("expiresAt", fileShareCreateResponse.expiresAt);
    writer.writeGuidValue("fileId", fileShareCreateResponse.fileId);
    writer.writeGuidValue("id", fileShareCreateResponse.id);
    writer.writeGuidValue("ownerId", fileShareCreateResponse.ownerId);
    writer.writeStringValue("status", fileShareCreateResponse.status);
    writer.writeStringValue("token", fileShareCreateResponse.token);
    writer.writeDateValue("updatedAt", fileShareCreateResponse.updatedAt);
    writer.writeAdditionalData(fileShareCreateResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param FileShareResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeFileShareResponse(writer: SerializationWriter, fileShareResponse: Partial<FileShareResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!fileShareResponse || isSerializingDerivedType) { return; }
    writer.writeStringValue("access", fileShareResponse.access);
    writer.writeDateValue("createdAt", fileShareResponse.createdAt);
    writer.writeDateValue("expiresAt", fileShareResponse.expiresAt);
    writer.writeGuidValue("fileId", fileShareResponse.fileId);
    writer.writeGuidValue("id", fileShareResponse.id);
    writer.writeGuidValue("ownerId", fileShareResponse.ownerId);
    writer.writeStringValue("status", fileShareResponse.status);
    writer.writeDateValue("updatedAt", fileShareResponse.updatedAt);
    writer.writeAdditionalData(fileShareResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param ForgotPasswordRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeForgotPasswordRequest(writer: SerializationWriter, forgotPasswordRequest: Partial<ForgotPasswordRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!forgotPasswordRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("email", forgotPasswordRequest.email);
    writer.writeStringValue("redirectTo", forgotPasswordRequest.redirectTo);
    writer.writeAdditionalData(forgotPasswordRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param HttpValidationProblemDetails The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeHttpValidationProblemDetails(writer: SerializationWriter, httpValidationProblemDetails: Partial<HttpValidationProblemDetails> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!httpValidationProblemDetails || isSerializingDerivedType) { return; }
    writer.writeStringValue("detail", httpValidationProblemDetails.detail);
    writer.writeObjectValue<HttpValidationProblemDetails_errors>("errors", httpValidationProblemDetails.errors, serializeHttpValidationProblemDetails_errors);
    writer.writeStringValue("instance", httpValidationProblemDetails.instance);
    writer.writeNumberValue("status", httpValidationProblemDetails.status);
    writer.writeStringValue("title", httpValidationProblemDetails.title);
    writer.writeStringValue("type", httpValidationProblemDetails.type);
    writer.writeAdditionalData(httpValidationProblemDetails.additionalData);
}
/**
 * Serializes information the current object
 * @param HttpValidationProblemDetails_errors The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeHttpValidationProblemDetails_errors(writer: SerializationWriter, httpValidationProblemDetails_errors: Partial<HttpValidationProblemDetails_errors> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!httpValidationProblemDetails_errors || isSerializingDerivedType) { return; }
    writer.writeAdditionalData(httpValidationProblemDetails_errors.additionalData);
}
/**
 * Serializes information the current object
 * @param IdentifyDynamicWatermarkRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeIdentifyDynamicWatermarkRequest(writer: SerializationWriter, identifyDynamicWatermarkRequest: Partial<IdentifyDynamicWatermarkRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!identifyDynamicWatermarkRequest || isSerializingDerivedType) { return; }
    writer.writeGuidValue("fileId", identifyDynamicWatermarkRequest.fileId);
    writer.writeCollectionOfObjectValues<WatermarkPoint>("points", identifyDynamicWatermarkRequest.points, serializeWatermarkPoint);
    writer.writeNumberValue("tolerance", identifyDynamicWatermarkRequest.tolerance);
    writer.writeAdditionalData(identifyDynamicWatermarkRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param IdentifyDynamicWatermarkResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeIdentifyDynamicWatermarkResponse(writer: SerializationWriter, identifyDynamicWatermarkResponse: Partial<IdentifyDynamicWatermarkResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!identifyDynamicWatermarkResponse || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("ambiguous", identifyDynamicWatermarkResponse.ambiguous);
    writer.writeNumberValue("candidatesEvaluated", identifyDynamicWatermarkResponse.candidatesEvaluated);
    writer.writeCollectionOfObjectValues<DynamicWatermarkMatchResponse>("matches", identifyDynamicWatermarkResponse.matches, serializeDynamicWatermarkMatchResponse);
    writer.writeNumberValue("pointsEvaluated", identifyDynamicWatermarkResponse.pointsEvaluated);
    writer.writeNumberValue("totalMatches", identifyDynamicWatermarkResponse.totalMatches);
    writer.writeBooleanValue("weakPattern", identifyDynamicWatermarkResponse.weakPattern);
    writer.writeAdditionalData(identifyDynamicWatermarkResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param IError The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeIError(writer: SerializationWriter, iError: Partial<IError> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!iError || isSerializingDerivedType) { return; }
    writer.writeStringValue("message", iError.messageEscaped);
    writer.writeAdditionalData(iError.additionalData);
}
/**
 * Serializes information the current object
 * @param ImageWatermarkPresetResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeImageWatermarkPresetResponse(writer: SerializationWriter, imageWatermarkPresetResponse: Partial<ImageWatermarkPresetResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!imageWatermarkPresetResponse || isSerializingDerivedType) { return; }
    writer.writeNumberValue("count", imageWatermarkPresetResponse.count);
    writer.writeDateValue("createdAt", imageWatermarkPresetResponse.createdAt);
    writer.writeGuidValue("id", imageWatermarkPresetResponse.id);
    writer.writeGuidValue("imageWatermarkId", imageWatermarkPresetResponse.imageWatermarkId);
    writer.writeStringValue("imageWatermarkName", imageWatermarkPresetResponse.imageWatermarkName);
    writer.writeStringValue("name", imageWatermarkPresetResponse.name);
    writer.writeNumberValue("opacity", imageWatermarkPresetResponse.opacity);
    writer.writeStringValue("placementMode", imageWatermarkPresetResponse.placementMode);
    writer.writeStringValue("position", imageWatermarkPresetResponse.position);
    writer.writeStringValue("status", imageWatermarkPresetResponse.status);
    writer.writeDateValue("updatedAt", imageWatermarkPresetResponse.updatedAt);
    writer.writeAdditionalData(imageWatermarkPresetResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param ImageWatermarkResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeImageWatermarkResponse(writer: SerializationWriter, imageWatermarkResponse: Partial<ImageWatermarkResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!imageWatermarkResponse || isSerializingDerivedType) { return; }
    writer.writeStringValue("contentType", imageWatermarkResponse.contentType);
    writer.writeDateValue("createdAt", imageWatermarkResponse.createdAt);
    writer.writeStringValue("downloadUrl", imageWatermarkResponse.downloadUrl);
    writer.writeGuidValue("id", imageWatermarkResponse.id);
    writer.writeStringValue("name", imageWatermarkResponse.name);
    writer.writeNumberValue("size", imageWatermarkResponse.size);
    writer.writeStringValue("status", imageWatermarkResponse.status);
    writer.writeDateValue("updatedAt", imageWatermarkResponse.updatedAt);
    writer.writeAdditionalData(imageWatermarkResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param ImageWatermarkUploadResponse The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeImageWatermarkUploadResponse(writer: SerializationWriter, imageWatermarkUploadResponse: Partial<ImageWatermarkUploadResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!imageWatermarkUploadResponse || isSerializingDerivedType) { return; }
    writer.writeDateValue("expiresAt", imageWatermarkUploadResponse.expiresAt);
    writer.writeGuidValue("imageWatermarkId", imageWatermarkUploadResponse.imageWatermarkId);
    writer.writeCollectionOfObjectValues<PresignedPartUrl>("partUrls", imageWatermarkUploadResponse.partUrls, serializePresignedPartUrl);
    writer.writeStringValue("uploadId", imageWatermarkUploadResponse.uploadId);
    writer.writeAdditionalData(imageWatermarkUploadResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param InitiateFileUploadRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInitiateFileUploadRequest(writer: SerializationWriter, initiateFileUploadRequest: Partial<InitiateFileUploadRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!initiateFileUploadRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("contentType", initiateFileUploadRequest.contentType);
    writer.writeGuidValue("directoryId", initiateFileUploadRequest.directoryId);
    writer.writeStringValue("fileName", initiateFileUploadRequest.fileName);
    writer.writeNumberValue("partCount", initiateFileUploadRequest.partCount);
    writer.writeNumberValue("partSize", initiateFileUploadRequest.partSize);
    writer.writeStringValue("persistance", initiateFileUploadRequest.persistance);
    writer.writeNumberValue("size", initiateFileUploadRequest.size);
    writer.writeNumberValue("ttlSeconds", initiateFileUploadRequest.ttlSeconds);
    writer.writeAdditionalData(initiateFileUploadRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param InitiateImageWatermarkUploadRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInitiateImageWatermarkUploadRequest(writer: SerializationWriter, initiateImageWatermarkUploadRequest: Partial<InitiateImageWatermarkUploadRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!initiateImageWatermarkUploadRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("contentType", initiateImageWatermarkUploadRequest.contentType);
    writer.writeStringValue("name", initiateImageWatermarkUploadRequest.name);
    writer.writeNumberValue("partCount", initiateImageWatermarkUploadRequest.partCount);
    writer.writeNumberValue("size", initiateImageWatermarkUploadRequest.size);
    writer.writeAdditionalData(initiateImageWatermarkUploadRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param InitiateRevisionUploadRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInitiateRevisionUploadRequest(writer: SerializationWriter, initiateRevisionUploadRequest: Partial<InitiateRevisionUploadRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!initiateRevisionUploadRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("contentType", initiateRevisionUploadRequest.contentType);
    writer.writeGuidValue("parentRevisionId", initiateRevisionUploadRequest.parentRevisionId);
    writer.writeNumberValue("partCount", initiateRevisionUploadRequest.partCount);
    writer.writeStringValue("persistance", initiateRevisionUploadRequest.persistance);
    writer.writeStringValue("revisionName", initiateRevisionUploadRequest.revisionName);
    writer.writeNumberValue("size", initiateRevisionUploadRequest.size);
    writer.writeNumberValue("ttlSeconds", initiateRevisionUploadRequest.ttlSeconds);
    writer.writeAdditionalData(initiateRevisionUploadRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param InitiateVideoAudioInputUploadRequest The instance to serialize from.
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeInitiateVideoAudioInputUploadRequest(writer: SerializationWriter, initiateVideoAudioInputUploadRequest: Partial<InitiateVideoAudioInputUploadRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!initiateVideoAudioInputUploadRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("contentType", initiateVideoAudioInputUploadRequest.contentType);
    writer.writeStringValue("fileName", initiateVideoAudioInputUploadRequest.fileName);
    writer.writeNumberValue("partCount", initiateVideoAudioInputUploadRequest.partCount);
    writer.writeNumberValue("size", initiateVideoAudioInputUploadRequest.size);
    writer.writeAdditionalData(initiateVideoAudioInputUploadRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param JobListResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeJobListResponse(writer: SerializationWriter, jobListResponse: Partial<JobListResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!jobListResponse || isSerializingDerivedType) { return; }
    writer.writeDateValue("createdAt", jobListResponse.createdAt);
    writer.writeGuidValue("fileId", jobListResponse.fileId);
    writer.writeStringValue("fileName", jobListResponse.fileName);
    writer.writeGuidValue("id", jobListResponse.id);
    writer.writeGuidValue("ownerId", jobListResponse.ownerId);
    writer.writeStringValue("revisionName", jobListResponse.revisionName);
    writer.writeStringValue("status", jobListResponse.status);
    writer.writeStringValue("statusMessage", jobListResponse.statusMessage);
    writer.writeStringValue("type", jobListResponse.type);
    writer.writeDateValue("updatedAt", jobListResponse.updatedAt);
    writer.writeAdditionalData(jobListResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param JobResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeJobResponse(writer: SerializationWriter, jobResponse: Partial<JobResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!jobResponse || isSerializingDerivedType) { return; }
    writer.writeGuidValue("jobId", jobResponse.jobId);
    writer.writeAdditionalData(jobResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param JobStatusResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeJobStatusResponse(writer: SerializationWriter, jobStatusResponse: Partial<JobStatusResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!jobStatusResponse || isSerializingDerivedType) { return; }
    writer.writeDateValue("createdAt", jobStatusResponse.createdAt);
    writer.writeGuidValue("id", jobStatusResponse.id);
    writer.writeStringValue("status", jobStatusResponse.status);
    writer.writeStringValue("statusMessage", jobStatusResponse.statusMessage);
    writer.writeStringValue("type", jobStatusResponse.type);
    writer.writeDateValue("updatedAt", jobStatusResponse.updatedAt);
    writer.writeAdditionalData(jobStatusResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param MultipartUploadResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeMultipartUploadResponse(writer: SerializationWriter, multipartUploadResponse: Partial<MultipartUploadResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!multipartUploadResponse || isSerializingDerivedType) { return; }
    writer.writeDateValue("expiresAt", multipartUploadResponse.expiresAt);
    writer.writeGuidValue("fileId", multipartUploadResponse.fileId);
    writer.writeNumberValue("partSize", multipartUploadResponse.partSize);
    writer.writeCollectionOfObjectValues<PresignedPartUrl>("partUrls", multipartUploadResponse.partUrls, serializePresignedPartUrl);
    writer.writeGuidValue("revisionId", multipartUploadResponse.revisionId);
    writer.writeStringValue("uploadId", multipartUploadResponse.uploadId);
    writer.writeAdditionalData(multipartUploadResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param NotificationResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeNotificationResponse(writer: SerializationWriter, notificationResponse: Partial<NotificationResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!notificationResponse || isSerializingDerivedType) { return; }
    writer.writeDateValue("createdAt", notificationResponse.createdAt);
    writer.writeGuidValue("id", notificationResponse.id);
    writer.writeBooleanValue("isRead", notificationResponse.isRead);
    writer.writeStringValue("message", notificationResponse.message);
    writer.writeStringValue("path", notificationResponse.path);
    writer.writeGuidValue("userId", notificationResponse.userId);
    writer.writeAdditionalData(notificationResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedResultOfArchivedFileRevisionResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedResultOfArchivedFileRevisionResponse(writer: SerializationWriter, paginatedResultOfArchivedFileRevisionResponse: Partial<PaginatedResultOfArchivedFileRevisionResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedResultOfArchivedFileRevisionResponse || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedResultOfArchivedFileRevisionResponse.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedResultOfArchivedFileRevisionResponse.hasPreviousPage);
    writer.writeCollectionOfObjectValues<ArchivedFileRevisionResponse>("items", paginatedResultOfArchivedFileRevisionResponse.items, serializeArchivedFileRevisionResponse);
    writer.writeNumberValue("page", paginatedResultOfArchivedFileRevisionResponse.page);
    writer.writeNumberValue("pageSize", paginatedResultOfArchivedFileRevisionResponse.pageSize);
    writer.writeNumberValue("totalCount", paginatedResultOfArchivedFileRevisionResponse.totalCount);
    writer.writeNumberValue("totalPages", paginatedResultOfArchivedFileRevisionResponse.totalPages);
    writer.writeAdditionalData(paginatedResultOfArchivedFileRevisionResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedResultOfDirectoryResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedResultOfDirectoryResponse(writer: SerializationWriter, paginatedResultOfDirectoryResponse: Partial<PaginatedResultOfDirectoryResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedResultOfDirectoryResponse || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedResultOfDirectoryResponse.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedResultOfDirectoryResponse.hasPreviousPage);
    writer.writeCollectionOfObjectValues<DirectoryResponse>("items", paginatedResultOfDirectoryResponse.items, serializeDirectoryResponse);
    writer.writeNumberValue("page", paginatedResultOfDirectoryResponse.page);
    writer.writeNumberValue("pageSize", paginatedResultOfDirectoryResponse.pageSize);
    writer.writeNumberValue("totalCount", paginatedResultOfDirectoryResponse.totalCount);
    writer.writeNumberValue("totalPages", paginatedResultOfDirectoryResponse.totalPages);
    writer.writeAdditionalData(paginatedResultOfDirectoryResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedResultOfDirectoryShareResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedResultOfDirectoryShareResponse(writer: SerializationWriter, paginatedResultOfDirectoryShareResponse: Partial<PaginatedResultOfDirectoryShareResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedResultOfDirectoryShareResponse || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedResultOfDirectoryShareResponse.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedResultOfDirectoryShareResponse.hasPreviousPage);
    writer.writeCollectionOfObjectValues<DirectoryShareResponse>("items", paginatedResultOfDirectoryShareResponse.items, serializeDirectoryShareResponse);
    writer.writeNumberValue("page", paginatedResultOfDirectoryShareResponse.page);
    writer.writeNumberValue("pageSize", paginatedResultOfDirectoryShareResponse.pageSize);
    writer.writeNumberValue("totalCount", paginatedResultOfDirectoryShareResponse.totalCount);
    writer.writeNumberValue("totalPages", paginatedResultOfDirectoryShareResponse.totalPages);
    writer.writeAdditionalData(paginatedResultOfDirectoryShareResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedResultOfFilePreviewGroupedResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedResultOfFilePreviewGroupedResponse(writer: SerializationWriter, paginatedResultOfFilePreviewGroupedResponse: Partial<PaginatedResultOfFilePreviewGroupedResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedResultOfFilePreviewGroupedResponse || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedResultOfFilePreviewGroupedResponse.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedResultOfFilePreviewGroupedResponse.hasPreviousPage);
    writer.writeCollectionOfObjectValues<FilePreviewGroupedResponse>("items", paginatedResultOfFilePreviewGroupedResponse.items, serializeFilePreviewGroupedResponse);
    writer.writeNumberValue("page", paginatedResultOfFilePreviewGroupedResponse.page);
    writer.writeNumberValue("pageSize", paginatedResultOfFilePreviewGroupedResponse.pageSize);
    writer.writeNumberValue("totalCount", paginatedResultOfFilePreviewGroupedResponse.totalCount);
    writer.writeNumberValue("totalPages", paginatedResultOfFilePreviewGroupedResponse.totalPages);
    writer.writeAdditionalData(paginatedResultOfFilePreviewGroupedResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedResultOfFileResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedResultOfFileResponse(writer: SerializationWriter, paginatedResultOfFileResponse: Partial<PaginatedResultOfFileResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedResultOfFileResponse || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedResultOfFileResponse.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedResultOfFileResponse.hasPreviousPage);
    writer.writeCollectionOfObjectValues<FileResponse>("items", paginatedResultOfFileResponse.items, serializeFileResponse);
    writer.writeNumberValue("page", paginatedResultOfFileResponse.page);
    writer.writeNumberValue("pageSize", paginatedResultOfFileResponse.pageSize);
    writer.writeNumberValue("totalCount", paginatedResultOfFileResponse.totalCount);
    writer.writeNumberValue("totalPages", paginatedResultOfFileResponse.totalPages);
    writer.writeAdditionalData(paginatedResultOfFileResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedResultOfFileRevisionResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedResultOfFileRevisionResponse(writer: SerializationWriter, paginatedResultOfFileRevisionResponse: Partial<PaginatedResultOfFileRevisionResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedResultOfFileRevisionResponse || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedResultOfFileRevisionResponse.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedResultOfFileRevisionResponse.hasPreviousPage);
    writer.writeCollectionOfObjectValues<FileRevisionResponse>("items", paginatedResultOfFileRevisionResponse.items, serializeFileRevisionResponse);
    writer.writeNumberValue("page", paginatedResultOfFileRevisionResponse.page);
    writer.writeNumberValue("pageSize", paginatedResultOfFileRevisionResponse.pageSize);
    writer.writeNumberValue("totalCount", paginatedResultOfFileRevisionResponse.totalCount);
    writer.writeNumberValue("totalPages", paginatedResultOfFileRevisionResponse.totalPages);
    writer.writeAdditionalData(paginatedResultOfFileRevisionResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedResultOfFileShareResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedResultOfFileShareResponse(writer: SerializationWriter, paginatedResultOfFileShareResponse: Partial<PaginatedResultOfFileShareResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedResultOfFileShareResponse || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedResultOfFileShareResponse.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedResultOfFileShareResponse.hasPreviousPage);
    writer.writeCollectionOfObjectValues<FileShareResponse>("items", paginatedResultOfFileShareResponse.items, serializeFileShareResponse);
    writer.writeNumberValue("page", paginatedResultOfFileShareResponse.page);
    writer.writeNumberValue("pageSize", paginatedResultOfFileShareResponse.pageSize);
    writer.writeNumberValue("totalCount", paginatedResultOfFileShareResponse.totalCount);
    writer.writeNumberValue("totalPages", paginatedResultOfFileShareResponse.totalPages);
    writer.writeAdditionalData(paginatedResultOfFileShareResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedResultOfImageWatermarkPresetResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedResultOfImageWatermarkPresetResponse(writer: SerializationWriter, paginatedResultOfImageWatermarkPresetResponse: Partial<PaginatedResultOfImageWatermarkPresetResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedResultOfImageWatermarkPresetResponse || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedResultOfImageWatermarkPresetResponse.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedResultOfImageWatermarkPresetResponse.hasPreviousPage);
    writer.writeCollectionOfObjectValues<ImageWatermarkPresetResponse>("items", paginatedResultOfImageWatermarkPresetResponse.items, serializeImageWatermarkPresetResponse);
    writer.writeNumberValue("page", paginatedResultOfImageWatermarkPresetResponse.page);
    writer.writeNumberValue("pageSize", paginatedResultOfImageWatermarkPresetResponse.pageSize);
    writer.writeNumberValue("totalCount", paginatedResultOfImageWatermarkPresetResponse.totalCount);
    writer.writeNumberValue("totalPages", paginatedResultOfImageWatermarkPresetResponse.totalPages);
    writer.writeAdditionalData(paginatedResultOfImageWatermarkPresetResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedResultOfImageWatermarkResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedResultOfImageWatermarkResponse(writer: SerializationWriter, paginatedResultOfImageWatermarkResponse: Partial<PaginatedResultOfImageWatermarkResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedResultOfImageWatermarkResponse || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedResultOfImageWatermarkResponse.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedResultOfImageWatermarkResponse.hasPreviousPage);
    writer.writeCollectionOfObjectValues<ImageWatermarkResponse>("items", paginatedResultOfImageWatermarkResponse.items, serializeImageWatermarkResponse);
    writer.writeNumberValue("page", paginatedResultOfImageWatermarkResponse.page);
    writer.writeNumberValue("pageSize", paginatedResultOfImageWatermarkResponse.pageSize);
    writer.writeNumberValue("totalCount", paginatedResultOfImageWatermarkResponse.totalCount);
    writer.writeNumberValue("totalPages", paginatedResultOfImageWatermarkResponse.totalPages);
    writer.writeAdditionalData(paginatedResultOfImageWatermarkResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedResultOfJobListResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedResultOfJobListResponse(writer: SerializationWriter, paginatedResultOfJobListResponse: Partial<PaginatedResultOfJobListResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedResultOfJobListResponse || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedResultOfJobListResponse.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedResultOfJobListResponse.hasPreviousPage);
    writer.writeCollectionOfObjectValues<JobListResponse>("items", paginatedResultOfJobListResponse.items, serializeJobListResponse);
    writer.writeNumberValue("page", paginatedResultOfJobListResponse.page);
    writer.writeNumberValue("pageSize", paginatedResultOfJobListResponse.pageSize);
    writer.writeNumberValue("totalCount", paginatedResultOfJobListResponse.totalCount);
    writer.writeNumberValue("totalPages", paginatedResultOfJobListResponse.totalPages);
    writer.writeAdditionalData(paginatedResultOfJobListResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedResultOfNotificationResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedResultOfNotificationResponse(writer: SerializationWriter, paginatedResultOfNotificationResponse: Partial<PaginatedResultOfNotificationResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedResultOfNotificationResponse || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedResultOfNotificationResponse.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedResultOfNotificationResponse.hasPreviousPage);
    writer.writeCollectionOfObjectValues<NotificationResponse>("items", paginatedResultOfNotificationResponse.items, serializeNotificationResponse);
    writer.writeNumberValue("page", paginatedResultOfNotificationResponse.page);
    writer.writeNumberValue("pageSize", paginatedResultOfNotificationResponse.pageSize);
    writer.writeNumberValue("totalCount", paginatedResultOfNotificationResponse.totalCount);
    writer.writeNumberValue("totalPages", paginatedResultOfNotificationResponse.totalPages);
    writer.writeAdditionalData(paginatedResultOfNotificationResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedResultOfPendingFileResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedResultOfPendingFileResponse(writer: SerializationWriter, paginatedResultOfPendingFileResponse: Partial<PaginatedResultOfPendingFileResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedResultOfPendingFileResponse || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedResultOfPendingFileResponse.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedResultOfPendingFileResponse.hasPreviousPage);
    writer.writeCollectionOfObjectValues<PendingFileResponse>("items", paginatedResultOfPendingFileResponse.items, serializePendingFileResponse);
    writer.writeNumberValue("page", paginatedResultOfPendingFileResponse.page);
    writer.writeNumberValue("pageSize", paginatedResultOfPendingFileResponse.pageSize);
    writer.writeNumberValue("totalCount", paginatedResultOfPendingFileResponse.totalCount);
    writer.writeNumberValue("totalPages", paginatedResultOfPendingFileResponse.totalPages);
    writer.writeAdditionalData(paginatedResultOfPendingFileResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedResultOfPendingRevisionResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedResultOfPendingRevisionResponse(writer: SerializationWriter, paginatedResultOfPendingRevisionResponse: Partial<PaginatedResultOfPendingRevisionResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedResultOfPendingRevisionResponse || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedResultOfPendingRevisionResponse.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedResultOfPendingRevisionResponse.hasPreviousPage);
    writer.writeCollectionOfObjectValues<PendingRevisionResponse>("items", paginatedResultOfPendingRevisionResponse.items, serializePendingRevisionResponse);
    writer.writeNumberValue("page", paginatedResultOfPendingRevisionResponse.page);
    writer.writeNumberValue("pageSize", paginatedResultOfPendingRevisionResponse.pageSize);
    writer.writeNumberValue("totalCount", paginatedResultOfPendingRevisionResponse.totalCount);
    writer.writeNumberValue("totalPages", paginatedResultOfPendingRevisionResponse.totalPages);
    writer.writeAdditionalData(paginatedResultOfPendingRevisionResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedResultOfRevisionCommentResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedResultOfRevisionCommentResponse(writer: SerializationWriter, paginatedResultOfRevisionCommentResponse: Partial<PaginatedResultOfRevisionCommentResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedResultOfRevisionCommentResponse || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedResultOfRevisionCommentResponse.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedResultOfRevisionCommentResponse.hasPreviousPage);
    writer.writeCollectionOfObjectValues<RevisionCommentResponse>("items", paginatedResultOfRevisionCommentResponse.items, serializeRevisionCommentResponse);
    writer.writeNumberValue("page", paginatedResultOfRevisionCommentResponse.page);
    writer.writeNumberValue("pageSize", paginatedResultOfRevisionCommentResponse.pageSize);
    writer.writeNumberValue("totalCount", paginatedResultOfRevisionCommentResponse.totalCount);
    writer.writeNumberValue("totalPages", paginatedResultOfRevisionCommentResponse.totalPages);
    writer.writeAdditionalData(paginatedResultOfRevisionCommentResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedResultOfRevisionShareResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedResultOfRevisionShareResponse(writer: SerializationWriter, paginatedResultOfRevisionShareResponse: Partial<PaginatedResultOfRevisionShareResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedResultOfRevisionShareResponse || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedResultOfRevisionShareResponse.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedResultOfRevisionShareResponse.hasPreviousPage);
    writer.writeCollectionOfObjectValues<RevisionShareResponse>("items", paginatedResultOfRevisionShareResponse.items, serializeRevisionShareResponse);
    writer.writeNumberValue("page", paginatedResultOfRevisionShareResponse.page);
    writer.writeNumberValue("pageSize", paginatedResultOfRevisionShareResponse.pageSize);
    writer.writeNumberValue("totalCount", paginatedResultOfRevisionShareResponse.totalCount);
    writer.writeNumberValue("totalPages", paginatedResultOfRevisionShareResponse.totalPages);
    writer.writeAdditionalData(paginatedResultOfRevisionShareResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedResultOfTagResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedResultOfTagResponse(writer: SerializationWriter, paginatedResultOfTagResponse: Partial<PaginatedResultOfTagResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedResultOfTagResponse || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedResultOfTagResponse.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedResultOfTagResponse.hasPreviousPage);
    writer.writeCollectionOfObjectValues<TagResponse>("items", paginatedResultOfTagResponse.items, serializeTagResponse);
    writer.writeNumberValue("page", paginatedResultOfTagResponse.page);
    writer.writeNumberValue("pageSize", paginatedResultOfTagResponse.pageSize);
    writer.writeNumberValue("totalCount", paginatedResultOfTagResponse.totalCount);
    writer.writeNumberValue("totalPages", paginatedResultOfTagResponse.totalPages);
    writer.writeAdditionalData(paginatedResultOfTagResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaginatedResultOfTrashItemResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaginatedResultOfTrashItemResponse(writer: SerializationWriter, paginatedResultOfTrashItemResponse: Partial<PaginatedResultOfTrashItemResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paginatedResultOfTrashItemResponse || isSerializingDerivedType) { return; }
    writer.writeBooleanValue("hasNextPage", paginatedResultOfTrashItemResponse.hasNextPage);
    writer.writeBooleanValue("hasPreviousPage", paginatedResultOfTrashItemResponse.hasPreviousPage);
    writer.writeCollectionOfObjectValues<TrashItemResponse>("items", paginatedResultOfTrashItemResponse.items, serializeTrashItemResponse);
    writer.writeNumberValue("page", paginatedResultOfTrashItemResponse.page);
    writer.writeNumberValue("pageSize", paginatedResultOfTrashItemResponse.pageSize);
    writer.writeNumberValue("totalCount", paginatedResultOfTrashItemResponse.totalCount);
    writer.writeNumberValue("totalPages", paginatedResultOfTrashItemResponse.totalPages);
    writer.writeAdditionalData(paginatedResultOfTrashItemResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PaymentMethodResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePaymentMethodResponse(writer: SerializationWriter, paymentMethodResponse: Partial<PaymentMethodResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!paymentMethodResponse || isSerializingDerivedType) { return; }
    writer.writeStringValue("brand", paymentMethodResponse.brand);
    writer.writeNumberValue("expMonth", paymentMethodResponse.expMonth);
    writer.writeNumberValue("expYear", paymentMethodResponse.expYear);
    writer.writeStringValue("id", paymentMethodResponse.id);
    writer.writeBooleanValue("isDefault", paymentMethodResponse.isDefault);
    writer.writeStringValue("last4", paymentMethodResponse.last4);
    writer.writeAdditionalData(paymentMethodResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PendingFileResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePendingFileResponse(writer: SerializationWriter, pendingFileResponse: Partial<PendingFileResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!pendingFileResponse || isSerializingDerivedType) { return; }
    writer.writeStringValue("contentType", pendingFileResponse.contentType);
    writer.writeDateValue("createdAt", pendingFileResponse.createdAt);
    writer.writeGuidValue("directoryId", pendingFileResponse.directoryId);
    writer.writeStringValue("extUploadId", pendingFileResponse.extUploadId);
    writer.writeGuidValue("fileId", pendingFileResponse.fileId);
    writer.writeStringValue("fileName", pendingFileResponse.fileName);
    writer.writeStringValue("persistance", pendingFileResponse.persistance);
    writer.writeGuidValue("revisionId", pendingFileResponse.revisionId);
    writer.writeNumberValue("size", pendingFileResponse.size);
    writer.writeNumberValue("ttlSeconds", pendingFileResponse.ttlSeconds);
    writer.writeAdditionalData(pendingFileResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PendingRevisionResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePendingRevisionResponse(writer: SerializationWriter, pendingRevisionResponse: Partial<PendingRevisionResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!pendingRevisionResponse || isSerializingDerivedType) { return; }
    writer.writeStringValue("contentType", pendingRevisionResponse.contentType);
    writer.writeDateValue("createdAt", pendingRevisionResponse.createdAt);
    writer.writeStringValue("extUploadId", pendingRevisionResponse.extUploadId);
    writer.writeGuidValue("fileId", pendingRevisionResponse.fileId);
    writer.writeStringValue("fileName", pendingRevisionResponse.fileName);
    writer.writeStringValue("persistance", pendingRevisionResponse.persistance);
    writer.writeGuidValue("revisionId", pendingRevisionResponse.revisionId);
    writer.writeStringValue("revisionName", pendingRevisionResponse.revisionName);
    writer.writeNumberValue("size", pendingRevisionResponse.size);
    writer.writeNumberValue("ttlSeconds", pendingRevisionResponse.ttlSeconds);
    writer.writeAdditionalData(pendingRevisionResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param PresignedPartUrl The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializePresignedPartUrl(writer: SerializationWriter, presignedPartUrl: Partial<PresignedPartUrl> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!presignedPartUrl || isSerializingDerivedType) { return; }
    writer.writeNumberValue("partNumber", presignedPartUrl.partNumber);
    writer.writeStringValue("url", presignedPartUrl.url);
    writer.writeAdditionalData(presignedPartUrl.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param ResetPasswordRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeResetPasswordRequest(writer: SerializationWriter, resetPasswordRequest: Partial<ResetPasswordRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!resetPasswordRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("newPassword", resetPasswordRequest.newPassword);
    writer.writeStringValue("token", resetPasswordRequest.token);
    writer.writeAdditionalData(resetPasswordRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param ResumeUploadRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeResumeUploadRequest(writer: SerializationWriter, resumeUploadRequest: Partial<ResumeUploadRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!resumeUploadRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("partCount", resumeUploadRequest.partCount);
    writer.writeNumberValue("partSize", resumeUploadRequest.partSize);
    writer.writeAdditionalData(resumeUploadRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param RevisionCommentCreateRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRevisionCommentCreateRequest(writer: SerializationWriter, revisionCommentCreateRequest: Partial<RevisionCommentCreateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!revisionCommentCreateRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("content", revisionCommentCreateRequest.content);
    writer.writeCollectionOfObjectValues<RevisionCommentMentionDto>("mentions", revisionCommentCreateRequest.mentions, serializeRevisionCommentMentionDto);
    writer.writeAdditionalData(revisionCommentCreateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param RevisionCommentMentionDto The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRevisionCommentMentionDto(writer: SerializationWriter, revisionCommentMentionDto: Partial<RevisionCommentMentionDto> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!revisionCommentMentionDto || isSerializingDerivedType) { return; }
    writer.writeNumberValue("length", revisionCommentMentionDto.length);
    writer.writeNumberValue("start", revisionCommentMentionDto.start);
    writer.writeGuidValue("userId", revisionCommentMentionDto.userId);
    writer.writeAdditionalData(revisionCommentMentionDto.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param RevisionCommentResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRevisionCommentResponse(writer: SerializationWriter, revisionCommentResponse: Partial<RevisionCommentResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!revisionCommentResponse || isSerializingDerivedType) { return; }
    writer.writeGuidValue("authorId", revisionCommentResponse.authorId);
    writer.writeStringValue("content", revisionCommentResponse.content);
    writer.writeDateValue("createdAt", revisionCommentResponse.createdAt);
    writer.writeGuidValue("id", revisionCommentResponse.id);
    writer.writeCollectionOfObjectValues<RevisionCommentMentionDto>("mentions", revisionCommentResponse.mentions, serializeRevisionCommentMentionDto);
    writer.writeGuidValue("revisionId", revisionCommentResponse.revisionId);
    writer.writeStringValue("status", revisionCommentResponse.status);
    writer.writeDateValue("updatedAt", revisionCommentResponse.updatedAt);
    writer.writeAdditionalData(revisionCommentResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param RevisionCommentUpdateRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRevisionCommentUpdateRequest(writer: SerializationWriter, revisionCommentUpdateRequest: Partial<RevisionCommentUpdateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!revisionCommentUpdateRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("content", revisionCommentUpdateRequest.content);
    writer.writeCollectionOfObjectValues<RevisionCommentMentionDto>("mentions", revisionCommentUpdateRequest.mentions, serializeRevisionCommentMentionDto);
    writer.writeAdditionalData(revisionCommentUpdateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param RevisionNoteResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRevisionNoteResponse(writer: SerializationWriter, revisionNoteResponse: Partial<RevisionNoteResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!revisionNoteResponse || isSerializingDerivedType) { return; }
    writer.writeStringValue("content", revisionNoteResponse.content);
    writer.writeDateValue("createdAt", revisionNoteResponse.createdAt);
    writer.writeGuidValue("id", revisionNoteResponse.id);
    writer.writeGuidValue("revisionId", revisionNoteResponse.revisionId);
    writer.writeStringValue("status", revisionNoteResponse.status);
    writer.writeDateValue("updatedAt", revisionNoteResponse.updatedAt);
    writer.writeAdditionalData(revisionNoteResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param RevisionNoteUpsertRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRevisionNoteUpsertRequest(writer: SerializationWriter, revisionNoteUpsertRequest: Partial<RevisionNoteUpsertRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!revisionNoteUpsertRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("content", revisionNoteUpsertRequest.content);
    writer.writeAdditionalData(revisionNoteUpsertRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param RevisionShareCreateResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRevisionShareCreateResponse(writer: SerializationWriter, revisionShareCreateResponse: Partial<RevisionShareCreateResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!revisionShareCreateResponse || isSerializingDerivedType) { return; }
    writer.writeStringValue("access", revisionShareCreateResponse.access);
    writer.writeDateValue("createdAt", revisionShareCreateResponse.createdAt);
    writer.writeDateValue("expiresAt", revisionShareCreateResponse.expiresAt);
    writer.writeGuidValue("id", revisionShareCreateResponse.id);
    writer.writeGuidValue("ownerId", revisionShareCreateResponse.ownerId);
    writer.writeGuidValue("revisionId", revisionShareCreateResponse.revisionId);
    writer.writeStringValue("status", revisionShareCreateResponse.status);
    writer.writeStringValue("token", revisionShareCreateResponse.token);
    writer.writeDateValue("updatedAt", revisionShareCreateResponse.updatedAt);
    writer.writeAdditionalData(revisionShareCreateResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param RevisionShareResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeRevisionShareResponse(writer: SerializationWriter, revisionShareResponse: Partial<RevisionShareResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!revisionShareResponse || isSerializingDerivedType) { return; }
    writer.writeStringValue("access", revisionShareResponse.access);
    writer.writeDateValue("createdAt", revisionShareResponse.createdAt);
    writer.writeDateValue("expiresAt", revisionShareResponse.expiresAt);
    writer.writeGuidValue("id", revisionShareResponse.id);
    writer.writeGuidValue("ownerId", revisionShareResponse.ownerId);
    writer.writeGuidValue("revisionId", revisionShareResponse.revisionId);
    writer.writeStringValue("status", revisionShareResponse.status);
    writer.writeDateValue("updatedAt", revisionShareResponse.updatedAt);
    writer.writeAdditionalData(revisionShareResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param SetDefaultPaymentMethodRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSetDefaultPaymentMethodRequest(writer: SerializationWriter, setDefaultPaymentMethodRequest: Partial<SetDefaultPaymentMethodRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!setDefaultPaymentMethodRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("paymentMethodId", setDefaultPaymentMethodRequest.paymentMethodId);
    writer.writeAdditionalData(setDefaultPaymentMethodRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param SettingsUsageResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSettingsUsageResponse(writer: SerializationWriter, settingsUsageResponse: Partial<SettingsUsageResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!settingsUsageResponse || isSerializingDerivedType) { return; }
    writer.writeNumberValue("averageProcessingSeconds", settingsUsageResponse.averageProcessingSeconds);
    writer.writeNumberValue("completedJobs", settingsUsageResponse.completedJobs);
    writer.writeNumberValue("completedUploads", settingsUsageResponse.completedUploads);
    writer.writeDateValue("endDate", settingsUsageResponse.endDate);
    writer.writeNumberValue("failedJobs", settingsUsageResponse.failedJobs);
    writer.writeNumberValue("jobRuntimeLimitSeconds", settingsUsageResponse.jobRuntimeLimitSeconds);
    writer.writeNumberValue("processingSuccessRate", settingsUsageResponse.processingSuccessRate);
    writer.writeNumberValue("reclaimableTrashBytes", settingsUsageResponse.reclaimableTrashBytes);
    writer.writeNumberValue("revisionStorageBytes", settingsUsageResponse.revisionStorageBytes);
    writer.writeDateValue("startDate", settingsUsageResponse.startDate);
    writer.writeNumberValue("storageBytes", settingsUsageResponse.storageBytes);
    writer.writeNumberValue("storageLimitBytes", settingsUsageResponse.storageLimitBytes);
    writer.writeNumberValue("totalJobRuntimeSeconds", settingsUsageResponse.totalJobRuntimeSeconds);
    writer.writeAdditionalData(settingsUsageResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param ShareCreateRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeShareCreateRequest(writer: SerializationWriter, shareCreateRequest: Partial<ShareCreateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!shareCreateRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("access", shareCreateRequest.access);
    writer.writeDateValue("expiresAt", shareCreateRequest.expiresAt);
    writer.writeAdditionalData(shareCreateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param SharedDirectoryResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSharedDirectoryResponse(writer: SerializationWriter, sharedDirectoryResponse: Partial<SharedDirectoryResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!sharedDirectoryResponse || isSerializingDerivedType) { return; }
    writer.writeStringValue("access", sharedDirectoryResponse.access);
    writer.writeObjectValue<DirectoryResponse>("currentDirectory", sharedDirectoryResponse.currentDirectory, serializeDirectoryResponse);
    writer.writeObjectValue<PaginatedResultOfDirectoryResponse>("directories", sharedDirectoryResponse.directories, serializePaginatedResultOfDirectoryResponse);
    writer.writeObjectValue<PaginatedResultOfFileResponse>("files", sharedDirectoryResponse.files, serializePaginatedResultOfFileResponse);
    writer.writeGuidValue("rootDirectoryId", sharedDirectoryResponse.rootDirectoryId);
    writer.writeAdditionalData(sharedDirectoryResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param ShareUpdateRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeShareUpdateRequest(writer: SerializationWriter, shareUpdateRequest: Partial<ShareUpdateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!shareUpdateRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("access", shareUpdateRequest.access);
    writer.writeDateValue("expiresAt", shareUpdateRequest.expiresAt);
    writer.writeStringValue("status", shareUpdateRequest.status);
    writer.writeAdditionalData(shareUpdateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param StaticBlurRegionRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeStaticBlurRegionRequest(writer: SerializationWriter, staticBlurRegionRequest: Partial<StaticBlurRegionRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!staticBlurRegionRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("endSeconds", staticBlurRegionRequest.endSeconds);
    writer.writeNumberValue("height", staticBlurRegionRequest.height);
    writer.writeStringValue("mode", staticBlurRegionRequest.mode);
    writer.writeNumberValue("startSeconds", staticBlurRegionRequest.startSeconds);
    writer.writeNumberValue("strength", staticBlurRegionRequest.strength);
    writer.writeNumberValue("width", staticBlurRegionRequest.width);
    writer.writeNumberValue("x", staticBlurRegionRequest.x);
    writer.writeNumberValue("y", staticBlurRegionRequest.y);
    writer.writeAdditionalData(staticBlurRegionRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param SubscriptionAddonResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSubscriptionAddonResponse(writer: SerializationWriter, subscriptionAddonResponse: Partial<SubscriptionAddonResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!subscriptionAddonResponse || isSerializingDerivedType) { return; }
    writer.writeGuidValue("productId", subscriptionAddonResponse.productId);
    writer.writeStringValue("productName", subscriptionAddonResponse.productName);
    writer.writeNumberValue("quantity", subscriptionAddonResponse.quantity);
    writer.writeAdditionalData(subscriptionAddonResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param SubscriptionResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeSubscriptionResponse(writer: SerializationWriter, subscriptionResponse: Partial<SubscriptionResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!subscriptionResponse || isSerializingDerivedType) { return; }
    writer.writeCollectionOfObjectValues<SubscriptionAddonResponse>("addons", subscriptionResponse.addons, serializeSubscriptionAddonResponse);
    writer.writeBooleanValue("cancelAtPeriodEnd", subscriptionResponse.cancelAtPeriodEnd);
    writer.writeDateValue("currentPeriodEnd", subscriptionResponse.currentPeriodEnd);
    writer.writeDateValue("expiresAt", subscriptionResponse.expiresAt);
    writer.writeStringValue("externalSubscriptionStatus", subscriptionResponse.externalSubscriptionStatus);
    writer.writeGuidValue("id", subscriptionResponse.id);
    writer.writeGuidValue("productId", subscriptionResponse.productId);
    writer.writeStringValue("productName", subscriptionResponse.productName);
    writer.writeNumberValue("quantity", subscriptionResponse.quantity);
    writer.writeDateValue("startsAt", subscriptionResponse.startsAt);
    writer.writeStringValue("status", subscriptionResponse.status);
    writer.writeAdditionalData(subscriptionResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param TagCreateRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTagCreateRequest(writer: SerializationWriter, tagCreateRequest: Partial<TagCreateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!tagCreateRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("name", tagCreateRequest.name);
    writer.writeAdditionalData(tagCreateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param TagResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTagResponse(writer: SerializationWriter, tagResponse: Partial<TagResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!tagResponse || isSerializingDerivedType) { return; }
    writer.writeGuidValue("id", tagResponse.id);
    writer.writeStringValue("name", tagResponse.name);
    writer.writeAdditionalData(tagResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param TagUpdateRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTagUpdateRequest(writer: SerializationWriter, tagUpdateRequest: Partial<TagUpdateRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!tagUpdateRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("name", tagUpdateRequest.name);
    writer.writeAdditionalData(tagUpdateRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param TrashItemResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeTrashItemResponse(writer: SerializationWriter, trashItemResponse: Partial<TrashItemResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!trashItemResponse || isSerializingDerivedType) { return; }
    writer.writeCollectionOfPrimitiveValues<Guid>("ancestorDirectoryIds", trashItemResponse.ancestorDirectoryIds);
    writer.writeDateValue("archivedAt", trashItemResponse.archivedAt);
    writer.writeObjectValue<DirectoryResponse>("directory", trashItemResponse.directory, serializeDirectoryResponse);
    writer.writeObjectValue<FileResponse>("file", trashItemResponse.file, serializeFileResponse);
    writer.writeGuidValue("id", trashItemResponse.id);
    writer.writeStringValue("kind", trashItemResponse.kind);
    writer.writeObjectValue<ArchivedFileRevisionResponse>("revision", trashItemResponse.revision, serializeArchivedFileRevisionResponse);
    writer.writeAdditionalData(trashItemResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateAddonQuantityRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateAddonQuantityRequest(writer: SerializationWriter, updateAddonQuantityRequest: Partial<UpdateAddonQuantityRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateAddonQuantityRequest || isSerializingDerivedType) { return; }
    writer.writeGuidValue("productId", updateAddonQuantityRequest.productId);
    writer.writeNumberValue("quantity", updateAddonQuantityRequest.quantity);
    writer.writeAdditionalData(updateAddonQuantityRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateImageWatermarkPresetRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateImageWatermarkPresetRequest(writer: SerializationWriter, updateImageWatermarkPresetRequest: Partial<UpdateImageWatermarkPresetRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateImageWatermarkPresetRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("count", updateImageWatermarkPresetRequest.count);
    writer.writeStringValue("name", updateImageWatermarkPresetRequest.name);
    writer.writeNumberValue("opacity", updateImageWatermarkPresetRequest.opacity);
    writer.writeStringValue("placementMode", updateImageWatermarkPresetRequest.placementMode);
    writer.writeStringValue("position", updateImageWatermarkPresetRequest.position);
    writer.writeAdditionalData(updateImageWatermarkPresetRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param UpdateImageWatermarkRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeUpdateImageWatermarkRequest(writer: SerializationWriter, updateImageWatermarkRequest: Partial<UpdateImageWatermarkRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!updateImageWatermarkRequest || isSerializingDerivedType) { return; }
    writer.writeStringValue("name", updateImageWatermarkRequest.name);
    writer.writeAdditionalData(updateImageWatermarkRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param VideoAudioClipRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeVideoAudioClipRequest(writer: SerializationWriter, videoAudioClipRequest: Partial<VideoAudioClipRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!videoAudioClipRequest || isSerializingDerivedType) { return; }
    writer.writeGuidValue("audioInputId", videoAudioClipRequest.audioInputId);
    writer.writeNumberValue("sourceEndSeconds", videoAudioClipRequest.sourceEndSeconds);
    writer.writeNumberValue("sourceStartSeconds", videoAudioClipRequest.sourceStartSeconds);
    writer.writeNumberValue("videoStartSeconds", videoAudioClipRequest.videoStartSeconds);
    writer.writeNumberValue("volumePercent", videoAudioClipRequest.volumePercent);
    writer.writeAdditionalData(videoAudioClipRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param VideoAudioInputResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeVideoAudioInputResponse(writer: SerializationWriter, videoAudioInputResponse: Partial<VideoAudioInputResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!videoAudioInputResponse || isSerializingDerivedType) { return; }
    writer.writeStringValue("contentType", videoAudioInputResponse.contentType);
    writer.writeDateValue("expiresAt", videoAudioInputResponse.expiresAt);
    writer.writeStringValue("fileName", videoAudioInputResponse.fileName);
    writer.writeGuidValue("id", videoAudioInputResponse.id);
    writer.writeNumberValue("size", videoAudioInputResponse.size);
    writer.writeStringValue("status", videoAudioInputResponse.status);
    writer.writeAdditionalData(videoAudioInputResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param VideoAudioInputUploadResponse The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeVideoAudioInputUploadResponse(writer: SerializationWriter, videoAudioInputUploadResponse: Partial<VideoAudioInputUploadResponse> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!videoAudioInputUploadResponse || isSerializingDerivedType) { return; }
    writer.writeGuidValue("audioInputId", videoAudioInputUploadResponse.audioInputId);
    writer.writeDateValue("expiresAt", videoAudioInputUploadResponse.expiresAt);
    writer.writeCollectionOfObjectValues<PresignedPartUrl>("partUrls", videoAudioInputUploadResponse.partUrls, serializePresignedPartUrl);
    writer.writeStringValue("uploadId", videoAudioInputUploadResponse.uploadId);
    writer.writeAdditionalData(videoAudioInputUploadResponse.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param VideoTrimSectionRequest The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeVideoTrimSectionRequest(writer: SerializationWriter, videoTrimSectionRequest: Partial<VideoTrimSectionRequest> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!videoTrimSectionRequest || isSerializingDerivedType) { return; }
    writer.writeNumberValue("endSeconds", videoTrimSectionRequest.endSeconds);
    writer.writeNumberValue("startSeconds", videoTrimSectionRequest.startSeconds);
    writer.writeAdditionalData(videoTrimSectionRequest.additionalData);
}
/**
 * Serializes information the current object
 * @param isSerializingDerivedType A boolean indicating whether the serialization is for a derived type.
 * @param WatermarkPoint The instance to serialize from.
 * @param writer Serialization writer to use to serialize this model
 */
// @ts-ignore
export function serializeWatermarkPoint(writer: SerializationWriter, watermarkPoint: Partial<WatermarkPoint> | undefined | null = {}, isSerializingDerivedType: boolean = false) : void {
    if (!watermarkPoint || isSerializingDerivedType) { return; }
    writer.writeNumberValue("x", watermarkPoint.x);
    writer.writeNumberValue("y", watermarkPoint.y);
    writer.writeAdditionalData(watermarkPoint.additionalData);
}
export interface SetDefaultPaymentMethodRequest extends AdditionalDataHolder, Parsable {
    /**
     * The paymentMethodId property
     */
    paymentMethodId?: string | null;
}
export interface SettingsUsageResponse extends AdditionalDataHolder, Parsable {
    /**
     * The averageProcessingSeconds property
     */
    averageProcessingSeconds?: number | null;
    /**
     * The completedJobs property
     */
    completedJobs?: number | null;
    /**
     * The completedUploads property
     */
    completedUploads?: number | null;
    /**
     * The endDate property
     */
    endDate?: Date | null;
    /**
     * The failedJobs property
     */
    failedJobs?: number | null;
    /**
     * The jobRuntimeLimitSeconds property
     */
    jobRuntimeLimitSeconds?: number | null;
    /**
     * The processingSuccessRate property
     */
    processingSuccessRate?: number | null;
    /**
     * The reclaimableTrashBytes property
     */
    reclaimableTrashBytes?: number | null;
    /**
     * The revisionStorageBytes property
     */
    revisionStorageBytes?: number | null;
    /**
     * The startDate property
     */
    startDate?: Date | null;
    /**
     * The storageBytes property
     */
    storageBytes?: number | null;
    /**
     * The storageLimitBytes property
     */
    storageLimitBytes?: number | null;
    /**
     * The totalJobRuntimeSeconds property
     */
    totalJobRuntimeSeconds?: number | null;
}
export interface ShareCreateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The access property
     */
    access?: string | null;
    /**
     * The expiresAt property
     */
    expiresAt?: Date | null;
}
export interface SharedDirectoryResponse extends AdditionalDataHolder, Parsable {
    /**
     * The access property
     */
    access?: string | null;
    /**
     * The currentDirectory property
     */
    currentDirectory?: DirectoryResponse | null;
    /**
     * The directories property
     */
    directories?: PaginatedResultOfDirectoryResponse | null;
    /**
     * The files property
     */
    files?: PaginatedResultOfFileResponse | null;
    /**
     * The rootDirectoryId property
     */
    rootDirectoryId?: Guid | null;
}
export interface ShareUpdateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The access property
     */
    access?: string | null;
    /**
     * The expiresAt property
     */
    expiresAt?: Date | null;
    /**
     * The status property
     */
    status?: string | null;
}
export interface StaticBlurRegionRequest extends AdditionalDataHolder, Parsable {
    /**
     * The endSeconds property
     */
    endSeconds?: number | null;
    /**
     * The height property
     */
    height?: number | null;
    /**
     * The mode property
     */
    mode?: string | null;
    /**
     * The startSeconds property
     */
    startSeconds?: number | null;
    /**
     * The strength property
     */
    strength?: number | null;
    /**
     * The width property
     */
    width?: number | null;
    /**
     * The x property
     */
    x?: number | null;
    /**
     * The y property
     */
    y?: number | null;
}
export interface SubscriptionAddonResponse extends AdditionalDataHolder, Parsable {
    /**
     * The productId property
     */
    productId?: Guid | null;
    /**
     * The productName property
     */
    productName?: string | null;
    /**
     * The quantity property
     */
    quantity?: number | null;
}
export interface SubscriptionResponse extends AdditionalDataHolder, Parsable {
    /**
     * The addons property
     */
    addons?: SubscriptionAddonResponse[] | null;
    /**
     * The cancelAtPeriodEnd property
     */
    cancelAtPeriodEnd?: boolean | null;
    /**
     * The currentPeriodEnd property
     */
    currentPeriodEnd?: Date | null;
    /**
     * The expiresAt property
     */
    expiresAt?: Date | null;
    /**
     * The externalSubscriptionStatus property
     */
    externalSubscriptionStatus?: string | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The productId property
     */
    productId?: Guid | null;
    /**
     * The productName property
     */
    productName?: string | null;
    /**
     * The quantity property
     */
    quantity?: number | null;
    /**
     * The startsAt property
     */
    startsAt?: Date | null;
    /**
     * The status property
     */
    status?: string | null;
}
export interface TagCreateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The name property
     */
    name?: string | null;
}
export interface TagResponse extends AdditionalDataHolder, Parsable {
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The name property
     */
    name?: string | null;
}
export interface TagUpdateRequest extends AdditionalDataHolder, Parsable {
    /**
     * The name property
     */
    name?: string | null;
}
export interface TrashItemResponse extends AdditionalDataHolder, Parsable {
    /**
     * The ancestorDirectoryIds property
     */
    ancestorDirectoryIds?: Guid[] | null;
    /**
     * The archivedAt property
     */
    archivedAt?: Date | null;
    /**
     * The directory property
     */
    directory?: DirectoryResponse | null;
    /**
     * The file property
     */
    file?: FileResponse | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The kind property
     */
    kind?: string | null;
    /**
     * The revision property
     */
    revision?: ArchivedFileRevisionResponse | null;
}
export interface UpdateAddonQuantityRequest extends AdditionalDataHolder, Parsable {
    /**
     * The productId property
     */
    productId?: Guid | null;
    /**
     * The quantity property
     */
    quantity?: number | null;
}
export interface UpdateImageWatermarkPresetRequest extends AdditionalDataHolder, Parsable {
    /**
     * The count property
     */
    count?: number | null;
    /**
     * The name property
     */
    name?: string | null;
    /**
     * The opacity property
     */
    opacity?: number | null;
    /**
     * The placementMode property
     */
    placementMode?: string | null;
    /**
     * The position property
     */
    position?: string | null;
}
export interface UpdateImageWatermarkRequest extends AdditionalDataHolder, Parsable {
    /**
     * The name property
     */
    name?: string | null;
}
export interface VideoAudioClipRequest extends AdditionalDataHolder, Parsable {
    /**
     * The audioInputId property
     */
    audioInputId?: Guid | null;
    /**
     * The sourceEndSeconds property
     */
    sourceEndSeconds?: number | null;
    /**
     * The sourceStartSeconds property
     */
    sourceStartSeconds?: number | null;
    /**
     * The videoStartSeconds property
     */
    videoStartSeconds?: number | null;
    /**
     * The volumePercent property
     */
    volumePercent?: number | null;
}
export interface VideoAudioInputResponse extends AdditionalDataHolder, Parsable {
    /**
     * The contentType property
     */
    contentType?: string | null;
    /**
     * The expiresAt property
     */
    expiresAt?: Date | null;
    /**
     * The fileName property
     */
    fileName?: string | null;
    /**
     * The id property
     */
    id?: Guid | null;
    /**
     * The size property
     */
    size?: number | null;
    /**
     * The status property
     */
    status?: string | null;
}
export interface VideoAudioInputUploadResponse extends AdditionalDataHolder, Parsable {
    /**
     * The audioInputId property
     */
    audioInputId?: Guid | null;
    /**
     * The expiresAt property
     */
    expiresAt?: Date | null;
    /**
     * The partUrls property
     */
    partUrls?: PresignedPartUrl[] | null;
    /**
     * The uploadId property
     */
    uploadId?: string | null;
}
export interface VideoTrimSectionRequest extends AdditionalDataHolder, Parsable {
    /**
     * The endSeconds property
     */
    endSeconds?: number | null;
    /**
     * The startSeconds property
     */
    startSeconds?: number | null;
}
export interface WatermarkPoint extends AdditionalDataHolder, Parsable {
    /**
     * The x property
     */
    x?: number | null;
    /**
     * The y property
     */
    y?: number | null;
}
/* tslint:enable */
/* eslint-enable */
